import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { ExcursionServiceService } from '../service/excursion-service.service';
import { MessageService } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { Router, NavigationEnd  } from '@angular/router';
import { DataServiceService } from '../service/data-service.service';
import { ElementRef, ViewChildren, ViewChild } from '@angular/core';
import { Calendar } from 'primeng/calendar';
import { Table } from 'primeng/table';
import { environment } from  '../../environments/environment';
import { filter } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-excursion',
  templateUrl: './excursion.component.html',
  styleUrls: ['./excursion.component.css'],
  providers: [MessageService]
})
export class ExcursionComponent implements OnInit {
  @ViewChild(Table)
  dt!: Table;
  @ViewChild('theCalendar') public calendar!: Calendar;
  @Output() valueChange = new EventEmitter();
  
  defaultSupplier: string[] = environment.defaultSupplier;
  appClient: string = environment.appClient;
  toalcount = 'adult:0,child:0'
  ex_total_adult = 0
  ex_total_child = 0
  ex_total_unit = 0
  chart: any;
  cost_display: boolean = false;
  CopyDetails : boolean = false;
  CopyDetailsData : any = [];
  CopyText : any;
  adult_supplier_row: boolean = true;
  checkChildSupplier : boolean = true;
  supplier_chart: any;
  excursionPageIndex: number = 0;
  // @ViewChild('search') searchElement:any= ElementRef;
  // expandedRows={'485':1,'484':1,'486':1}
  search = 'search'
  //expandedRows = { "485": true, "484": true }
  expandedRows:any = [];
  total_adult = 0
  totoal_child = 0
  total_senior = 0
  total_unit = 0
  total_amout = 0
  is_multicost = 0
  cost_ACS = 0
  cost_unit = 0
  chartone: any;
  totalAdults:number = 0;
  totalChilds:number = 0;
  excursionForm = new FormGroup({
    excursion_from_date: new FormControl(new Date(), [Validators.required, Validators.minLength(3)]),
    excursion_to_date: new FormControl(new Date(), [Validators.required, Validators.email]),
    request_from_date: new FormControl('', Validators.required),
    request_to_date: new FormControl('', Validators.required),
    priority: new FormControl('', Validators.required),
    bussinessunit: new FormControl('', Validators.required),
    status: new FormControl('', Validators.required),
    searchkeyword: new FormControl('', Validators.required),
    sel_search_type: new FormControl(0, Validators.required),
    order_by: new FormControl('', Validators.required),
    excursion_types: new FormControl('', Validators.required),
    excursion_classification: new FormControl('', Validators.required),
    excursion_pickuplocation: new FormControl('', Validators.required),
    amendment: new FormControl('', Validators.required),
    offset: new FormControl('0', Validators.required),
    per_page: new FormControl('100', Validators.required),
    Supplier:new FormControl('',Validators.required)
  });
  constructor(private excursionServiceService: ExcursionServiceService,
    private toastrService: ToastrService, private router: Router, private data_service: DataServiceService,
    private datePipe: DatePipe) { }
  selectedCar: number | undefined;
  cost_adult = false
  cost_child = false
  cost_senior = false
  team_member_count: any = [];
  supplier_count: any = [];
  prioritylist: any = [];
  excursionlist: any = [];
  excursionlist_export:any = [];
  excursiondeails: any = [];
  classificationlist: any = [];
  excursion_typeslist: any = [];
  loading = true
  Product: any = [];
  searchText = '';
  location_list: any = [];
  hotel_list: any = []
  total_cost = 0
  total_profit = 0;
  supplierCostResult: any;

  critical_list = [{ 'id': 1, 'value': 'CRITICAL' }, { 'id': 0, 'value': 'NORMAL' }]
  comp_list = [{ 'id': 1, 'value': 'Yes' }, { 'id': 0, 'value': 'None' }]
  status_list = [{ 'id': 1, 'value': 'Pending' }, { 'id': 2, 'value': 'Assigned' }, { 'id': 3, 'value': 'Confirmed' }, { 'id': 5, 'value': 'Rejected' }]
  orderbylist: any = [{ "id": 0, "value": 'None' }, { "id": 1, "value": 'Service Date (New to Older)' }, { "id": 2, "value": 'Service Date (Old to Newer)' }, { "id": 3, "value": 'Request Date (New to Older)' }
    , { "id": 4, "value": 'Request Date (Old to Newer)' }, { "id": 5, "value": 'Request ID (New to Older)' }, { "id": 7, "value": 'Request ID (Old to Newer)' }, { "id": 6, "value": 'Agent ID' }];

  statuslist: any = [{ "id": '', "value": 'Show All' }, { "id": 1, "value": 'Pending' }, { "id": 2, "value": 'Assigned' }, { "id": 3, "value": 'Confirmed' }
    , { "id": 4, "value": 'Cancelled' }, { "id": 5, "value": 'Rejected' }];

  amendlist: any = [{ "id": '', "value": 'Show All' }, { "id": 1, "value": 'Yes' }, { "id": 0, "value": 'No' }]
  notification_list: any = [
    // { "id": 'email', "value": 'Email' }, 
    { "id": 'email with comment', "value": 'Email With Comment' }, 
    { "id": 'not required', "value": 'Not Required' }
  ]

  search_in: any = [{ "id": 0, "value": 'Everywhere' }, { "id": 1, "value": 'Agent' }, { "id": 2, "value": 'Supplier' }, { "id": 3, "value": 'Request ID' }]

  activeItem!: MenuItem;
  get f() { return this.excursionForm.controls; }
  // gettotal(adult:any,child:any){
  //   console.log(adult)
  //   this.ex_total_adult=this.ex_total_adult+(+adult)
  //   this.ex_total_child=this.ex_total_child+(+child)
  //   this.toalcount='adult:'+this.ex_total_adult+',child:'+this.ex_total_adult
  // }

  defaultSupplierExists(supplierCode:string): boolean {
    return this.defaultSupplier.includes(supplierCode);
  }

  searchkeyword() {
    this.excursionForm.patchValue({
      excursion_from_date: '',
      excursion_to_date: '',
      request_from_date: '',
      request_to_date: '',
      priority: '',
      // criticality:new FormControl('',Validators.required)
      status: '',

      order_by: '',
      excursion_types: '',
      excursion_classification: '',
      partyname: '',
      amendment: '',
      Supplier: ''
    })

    this.excursionForm.patchValue({
      order_by: 5,
    })

    this.excursionPageIndex = 0
    localStorage.setItem('excursionPageIndex', "0");
    this.loadexcursion(this.excursionForm.value)
  }
  excursion_serarch_FormSubmit(is_serachkey: any) {
    localStorage.setItem('excursionPageIndex', "0");
    this.excursionPageIndex = 0
    this.excursionForm.patchValue({
      sel_search_type: '',
      searchkeyword: '',

    })

    if(this.appClient == "RoyalPark"){
      this.excursionForm.patchValue({
        order_by: 5,
      })
    }

    //console.log(this.excursionForm.value)
    // //console.log(new Date(this.excursionForm.value['excursion_to_date']))
    if (this.excursionForm.value['excursion_to_date'] != '' && this.excursionForm.value['excursion_to_date'] != null) {
      if (this.excursionForm.value['excursion_from_date'] == '' || this.excursionForm.value['excursion_from_date'] == null) {
        this.toastrService.error('Invalid date', 'Title Error!', { closeButton: true, timeOut: 3000 });
        return
      }

      this.excursionForm.value['excursion_to_date'] = new Date(this.excursionForm.value['excursion_to_date'])
      this.excursionForm.value['excursion_from_date'] = new Date(this.excursionForm.value['excursion_from_date'])

      let date1 = new Date(this.excursionForm.value['excursion_from_date'].getTime() - this.excursionForm.value['excursion_from_date'].getTimezoneOffset() * 60000).toISOString();
      // this.excursionForm.value['excursion_from_date']=date1
      // this.excursionForm.value['excursion_from_date']=new Date(this.excursionForm.value['excursion_from_date'].getTime() - this.excursionForm.value['excursion_from_date'].getTimezoneOffset()*60000).toISOString();
      let date2 = new Date(this.excursionForm.value['excursion_to_date'].getTime() - this.excursionForm.value['excursion_to_date'].getTimezoneOffset() * 60000).toISOString();
      this.excursionForm.value['excursion_to_date'] = date2
      if (this.excursionServiceService.compareDates(date2, date1) == -1) {
        //console.log('jjj')
        this.toastrService.error('Invalid date', 'Title Error!', { closeButton: true, timeOut: 3000 });
        return
      }

    }
    if (this.excursionForm.value['request_to_date'] != '' && this.excursionForm.value['request_to_date'] != null) {
      if (this.excursionForm.value['request_from_date'] == '' || this.excursionForm.value['request_from_date'] == null) {
        this.toastrService.error('Invalid date', 'Title Error!', { closeButton: true, timeOut: 3000 });
        return
      }
      this.excursionForm.value['request_to_date'] = new Date(this.excursionForm.value['request_to_date'])
      this.excursionForm.value['request_to_date'] = new Date(this.excursionForm.value['request_to_date'].getTime() - this.excursionForm.value['request_to_date'].getTimezoneOffset() * 60000).toISOString();
      if (this.excursionServiceService.compareDates(this.excursionForm.value['request_to_date'], this.excursionForm.value['request_from_date']) == -1) {
        //console.log('jjjh')
        this.toastrService.error('Invalid date', 'Title Error!', { closeButton: true, timeOut: 3000 });
        return
      }

    }
    if (this.excursionForm.value['request_from_date'] != '' && this.excursionForm.value['request_from_date'] != null) {
      this.excursionForm.value['request_from_date'] = new Date(this.excursionForm.value['request_from_date'])
      this.excursionForm.value['request_from_date'] = new Date(this.excursionForm.value['request_from_date'].getTime() - this.excursionForm.value['request_from_date'].getTimezoneOffset() * 60000).toISOString();
    }
    if (this.excursionForm.value['excursion_from_date'] != '' && this.excursionForm.value['excursion_from_date'] != null) {
      this.excursionForm.value['excursion_from_date'] = new Date(this.excursionForm.value['excursion_from_date'])
      //console.log(this.excursionForm.value['excursion_from_date'])
      this.excursionForm.value['excursion_from_date'] = new Date(this.excursionForm.value['excursion_from_date'].getTime() - this.excursionForm.value['excursion_from_date'].getTimezoneOffset() * 60000).toISOString();
    }
    //   if(this.excursionForm.value['excursion_from_date']!='' && this.excursionForm.value['excursion_from_date']!=null){
    //   if (this.excursionServiceService.compareDates(this.excursionForm.value['excursion_from_date'],this.excursionForm.value['excursion_from_date'])==-1)
    //   {
    //     this.toastrService.error('Invalid date', 'Title Error!',{closeButton:true, timeOut: 3000});
    //     return
    //   }
    // }
    //   if (this.excursionForm.value['request_to_date']!='' && this.excursionForm.value['request_to_date']!=null){
    //   if (this.excursionServiceService.compareDates(this.excursionForm.value['request_to_date'] ,this.excursionForm.value['request_from_date'])==-1)
    //   {
    //     this.toastrService.error('Invalid date', 'Title Error!',{closeButton:true, timeOut: 3000});
    //     return
    //   }
    // }
    // let va=Object.assign({}, this.excursionForm.value);
    let va = { ...this.excursionForm.value };
    //console.log(this.excursionForm.value)
    let st_lo = va.excursion_pickuplocation
    let loca = va.excursion_pickuplocation != null ? va.excursion_pickuplocation.split(';') : ''
    if (va.excursion_pickuplocation != '' && va.excursion_pickuplocation != null) {
      va.excursion_pickuplocation = loca[1] == 'P' ? '' : loca[0]
      va.searchguestpickup = loca[1] == 'P' ? st_lo : ''
    }
    this.loadexcursion(va)

  }

  items: MenuItem[] = [];
  menutitle = 'supplier'
  displayPosition = false;
  is_serarch = false;
  getsupp(data: any) {
    //console.log(data)
  }

  showPricePopup(){
    this.cost_display = true;
  }

  async getSupplierList_async(va: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.excursionServiceService.getsupplier_list(va).subscribe(
        (res: any) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  

  async supplierOnClick(event: any, idx: any, pax_type: any) {
    if (event != undefined) {
      if (pax_type == 'Child' || pax_type == 'Child as Adult') {
        //console.log('Child Supplier clicked');

        var adultrow = [];
        adultrow = this.excursiondeails.supplierList.filter((r: any, index: any) => r.cost[0].paxType == "Adult");
        //console.log(adultrow);

        const filterList: any = [];
        adultrow.forEach((x: any, i: any) => {
          filterList.push(x['partycode']);
        });

        var sList: any = [];
        sList = this.supplier_list;
        const filteredList = sList.filter((item: { partycode: any; }) => filterList.includes(item.partycode));
        //console.log(filteredList);
        this.supplier_list = filteredList;
        //Commented by Ram 20-05-2024
        // this.excursionServiceService.getsupplier_list({}).subscribe((res: { [x: string]: any; }) => {
        //   if (res['result'] == 1) {
        //     //this.supplier_list = res['data']
        //     //console.log(res['data']);
        //     //console.log(filterList);
        //     sList = res['data'];
        //     const filteredList = sList.filter((item: { partycode: any; }) => filterList.includes(item.partycode));
        //     //console.log(filteredList);
        //     this.supplier_list = filteredList;
        //   }
        // });
        //End Commented 

      }
      else {
        //Commented by Ram 20-05-2024
        // this.excursionServiceService.getsupplier_list({}).subscribe((res: { [x: string]: any; }) => {
        //   if (res['result'] == 1) {
        //     this.supplier_list = res['data']
        //     //console.log(res['data']);
        //   }
        // });
        //End Commented

        this.supplier_list = this.supplier_list_copy;
      }

    }
  }

  async getSupplierCost_async(va: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.excursionServiceService.GetSupplierCost(va).subscribe(
        (res: any) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  async supplieronChangevalue(event: any, idx: any, pax_type: any) {

    if (event != undefined) {

      //console.log(event);
      //console.log(this.excursiondeails.supplierList[idx]);
      this.supplierCostResult = {};
      let excSuppList = this.excursiondeails.supplierList;
      console.log(excSuppList);

      var excParentSupplist = [];
      excParentSupplist = excSuppList.filter((r: any, index: any) => r.is_parent == 1);
      console.log(excParentSupplist);

      let exctypcode = "";
      if(excParentSupplist.length > 0){
        exctypcode = excParentSupplist[0].exctypcode;
      }

      if(this.appClient == "RoyalPark"){
        let excdate = excSuppList[idx]['excdate'].split('-');
        let formattedexcdate = excdate[2] + "/" + excdate[1] + "/" + excdate[0];
        let va ={
          "agentcode": "",
          "fromdate": formattedexcdate,
          "todate": formattedexcdate,
          "sectorgroupcode": "",
          "noofadults": excSuppList[idx].adults,
          "noofchild": excSuppList[idx].child,
          "childagestring": "",
          "noofsenior": excSuppList[idx].senior,
          "sourcectrycode": "",
          "exctypcode": exctypcode,
          //"exctypname": excSuppList[idx].sm_name,
          "vehiclecode": "",
          "selecteddate": "",
          "requestid": excSuppList[idx].requestid,
          "elineno": excSuppList[idx].elineno,
          "suppliercode": excSuppList[idx].partycode,
          "servicename": excSuppList[idx].sm_name
        }
        console.log(va);
        this.supplierCostResult = await this.getSupplierCost_async(va);
    
        if(this.supplierCostResult != null && this.supplierCostResult != undefined){
          if(this.supplierCostResult['result'] == 1){
            let costdetails = [];
            let multicostdetails = [];
            costdetails = this.supplierCostResult['data'][0]['CostDetails'];
            multicostdetails = this.supplierCostResult['data'][0]['MultiCostDetails'];

            if(this.excursiondeails.supplierList[idx]['cost'] != undefined){
              if(this.excursiondeails.supplierList[idx]['cost'].length == 0){

                if(excParentSupplist[0].is_multicost == 1){
                  this.excursiondeails.supplierList[idx]['adultprice'] = multicostdetails[0]['adultCost'];
                  this.excursiondeails.supplierList[idx]['childprice'] = multicostdetails[0]['childCost'];
                  this.excursiondeails.supplierList[idx]['unitprice'] = multicostdetails[0]['unitCost'];
                }
                else{
                  this.excursiondeails.supplierList[idx]['adultprice'] = costdetails[0]['adultcPrice'];
                  this.excursiondeails.supplierList[idx]['childprice'] = costdetails[0]['childcPrice'];
                  this.excursiondeails.supplierList[idx]['unitprice'] = costdetails[0]['unitcPrice'];
                }
              }
            }

            for(let i=0; i<this.excursiondeails.supplierList[idx]['cost'].length; i++){
              if(excParentSupplist.length > 0){
                if(excParentSupplist[0].is_multicost == 1){
                  if(multicostdetails != undefined && multicostdetails != null && multicostdetails.length > 0){
                    if(this.excursiondeails.supplierList[idx]['cost'][i]['paxType'] == "Adult"){
                      this.excursiondeails.supplierList[idx]['cost'][i]['paxOrUnitRate'] = multicostdetails[0]['perAdult'];
                      this.adultchange_forSupCost(multicostdetails[0]['perAdult'], i, idx);
                    }
                    else if(this.excursiondeails.supplierList[idx]['cost'][i]['paxType'] == "Child" || this.excursiondeails.supplierList[idx]['cost'][i]['paxType'] == "Child as Adult"){
                      this.excursiondeails.supplierList[idx]['cost'][i]['paxOrUnitRate'] = multicostdetails[0]['perChild'];
                      this.adultchange_forSupCost(multicostdetails[0]['perChild'], i, idx);
                    }
                    else if(this.excursiondeails.supplierList[idx]['cost'][i]['paxType'] == "Unit"){
                      this.excursiondeails.supplierList[idx]['cost'][i]['paxOrUnitRate'] = multicostdetails[0]['unitCost'];
                      this.adultchange_forSupCost(multicostdetails[0]['unitCost'], i, idx);
                    }
                  }
                  else{
                    //this.excursiondeails.supplierList[idx]['cost'][i]['paxOrUnitRate'] = 0;
                    //this.adultchange_forSupCost(0, i, idx);
                  }
                }
                else{
                  if(costdetails != undefined && costdetails != null && costdetails.length > 0){
                    if(this.excursiondeails.supplierList[idx]['cost'][i]['paxType'] == "Adult"){
                      this.excursiondeails.supplierList[idx]['cost'][i]['paxOrUnitRate'] = costdetails[0]['adultcPrice'];
                      this.adultchange_forSupCost(costdetails[0]['adultcPrice'], i, idx);
                    }
                    else if(this.excursiondeails.supplierList[idx]['cost'][i]['paxType'] == "Child"){
                      this.excursiondeails.supplierList[idx]['cost'][i]['paxOrUnitRate'] = costdetails[0]['childcPrice']; //costdetails[0]['childAsAdultcPrice']
                      this.adultchange_forSupCost(costdetails[0]['childcPrice'], i, idx);
                    }
                    else if(this.excursiondeails.supplierList[idx]['cost'][i]['paxType'] == "Child as Adult"){
                      this.excursiondeails.supplierList[idx]['cost'][i]['paxOrUnitRate'] = costdetails[0]['childAsAdultcPrice']; //costdetails[0]['childAsAdultcPrice']
                      this.adultchange_forSupCost(costdetails[0]['childAsAdultcPrice'], i, idx);
                    }
                    else if(this.excursiondeails.supplierList[idx]['cost'][i]['paxType'] == "Unit"){
                      this.excursiondeails.supplierList[idx]['cost'][i]['paxOrUnitRate'] = costdetails[0]['unitcPrice'];
                      this.adultchange_forSupCost(costdetails[0]['unitcPrice'], i, idx);
                    }
                  }
                }
              }
            }
          }
        }
      }

      //if (pax_type != 'Child') { //Commented by Ram 10-07-2023
      this.excursiondeails.supplierList[idx]['sp_name'] = event.partyname;
      this.excursiondeails.supplierList[idx]['service_provider_id'] = event.partycode;
      this.excursiondeails.supplierList[idx]['partycode'] = event.partycode;

      if(this.appClient == "RoyalPark"){
        this.excursiondeails.supplierList[idx]['currcode'] = event.currcode;
      }

      //console.log(this.excursiondeails.supplierList[idx]);

      //console.log(event.partycode)

      //Commented by Ram default supplier dynamic check - 06-02-2024
      // if (this.excursiondeails.supplierList[idx]['service_provider_id'] != 'E/000041' && this.excursiondeails.supplierList[idx]['service_provider_id'] != 'T-000001') {
      //   this.excursiondeails.supplierList[idx]['serviceStatus'] = 3
      // }
      // else {
      //   this.excursiondeails.supplierList[idx]['serviceStatus'] = 1
      // }

      //Added by Ram default supplier dynamic check - 06-02-2024
      if(this.defaultSupplierExists(this.excursiondeails.supplierList[idx]['service_provider_id'])){
        this.excursiondeails.supplierList[idx]['serviceStatus'] = 1 // Pending
      }
      else{

        if(this.appClient != "RoyalPark"){
          this.excursiondeails.supplierList[idx]['serviceStatus'] = 3 // Confirmed
        }
        else if(this.appClient == "RoyalPark"){
          this.excursiondeails.supplierList[idx]['serviceStatus'] = 2 // Assigned
        }
        
      }

      //} //Commented by Ram 10-07-2023
      // else {
      //   // let li=this.excursiondeails.supplierList.filter((r:any)=>r.service_provider_id==event.partycode)
      //   if (this.excursiondeails.supplierList.filter((r: any) => r.service_provider_id == event.partycode).length != 0) {
      //     this.excursiondeails.supplierList[idx]['sp_name'] = event.partyname
      //     this.excursiondeails.supplierList[idx]['service_provider_id'] = event.partycode
      //     this.excursiondeails.supplierList[idx]['partycode'] = event.partycode
      //     //console.log(event.partycode)
      //     if (this.excursiondeails.supplierList[idx]['service_provider_id'] != 'E/000041' && this.excursiondeails.supplierList[idx]['service_provider_id'] != 'T-000001') {
      //       this.excursiondeails.supplierList[idx]['serviceStatus'] = 3
      //     }
      //     else {
      //       this.excursiondeails.supplierList[idx]['serviceStatus'] = 1
      //     }
      //   }
      //   else {

      //     this.excursiondeails.supplierList[idx]['service_provider_id'] = ''
      //     this.excursiondeails.supplierList[idx]['sp_name'] = ''
      //     // this.excursiondeails.supplierList[idx]['partycode']=''

      //     // event.partycode=this.excursiondeails.supplierList[0]['partycode']
      //     // event.partyname=this.excursiondeails.supplierList[0]['sp_name']
      //     this.toastrService.error('Please Select Adult based supplier ', 'Title Error!', { closeButton: true, timeOut: 3000 });
      //   }
      // }

      this.ResetSupplier_New();

    }

  }
  compensation_change(event: any, idx: any) {
    this.excursiondeails.supplierList[idx].cost[0].paxOrUnitRate = 0
    this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) - (+this.excursiondeails.supplierList[idx].cost[0].costValue)
    this.excursiondeails.supplierList[idx].cost[0].costValue = this.excursiondeails.supplierList[idx].cost[0].noofPaxOrUnit * 0
    this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) + (+this.excursiondeails.supplierList[idx].cost[0].costValue)
  }
  closedropdown(idx: any, pax_type: any) {
    //console.log('jj')
    if ((pax_type == 'Child' || pax_type == 'Child as Adult') && this.excursiondeails.supplierList.filter((r: any, index: any) => r.service_provider_id == this.excursiondeails.supplierList[idx]['partycode'] && index != idx && this.excursiondeails.supplierList[idx].cost.filter((s: any) => (s.paxType != 'Child' || s.paxType != 'Child as Adult'))).length == 0) {
      setTimeout(
        () => {
          this.excursiondeails.supplierList[idx]['sp_name'] = this.excursiondeails.supplierList[0]['sp_name']
          this.excursiondeails.supplierList[idx]['service_provider_id'] = this.excursiondeails.supplierList[0]['service_provider_id']
          this.excursiondeails.supplierList[idx]['partycode'] = this.excursiondeails.supplierList[0]['partycode']
        }, 100
      );
    }

  }

  ResetSupplier_New(isXClick:boolean = false){

    var adultrow: any = [];
    adultrow = this.excursiondeails.supplierList.filter((r: any, index: any) => r.cost.length != 0 &&  r.cost[0].paxType == "Adult");
    var childrow: any = [];
    childrow = this.excursiondeails.supplierList.filter((r: any, index: any) => r.cost.length != 0 &&  (r.cost[0].paxType == "Child" || r.cost[0].paxType == "Child as Adult"));

    var adultnosupplier: any = [];
    adultnosupplier = adultrow.filter((r: any, index: any) => r.partycode == "");
    var childnosupplier: any = [];
    childnosupplier = childrow.filter((r: any, index: any) => r.partycode == "");

    var adultsupplier: any = [];
    adultsupplier = adultrow.filter((r: any, index: any) => r.partycode != "");
    var childsupplier: any = [];
    childsupplier = childrow.filter((r: any, index: any) => r.partycode != "");

    if (adultrow.length == 1 && childrow.length == 1) {
      if ((adultrow[0].partycode != "" && childrow[0].partycode == "") ||
        (adultrow[0].partycode == "" && childrow[0].partycode != "")) {

        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == 'Child as Adult') {
              this.excursiondeails.supplierList[i]['service_provider_id'] = this.excursiondeails.supplierList[i - 1]['service_provider_id'];
              this.excursiondeails.supplierList[i]['sp_name'] = this.excursiondeails.supplierList[i - 1]['sp_name'];
              this.excursiondeails.supplierList[i]['partycode'] == this.excursiondeails.supplierList[i - 1]['partycode'];
              this.excursiondeails.supplierList[i]['serviceStatus'] = this.excursiondeails.supplierList[i - 1]['serviceStatus'];
              this.excursiondeails.supplierList[i]['partyname'] = this.excursiondeails.supplierList[i - 1]['sp_name'];
            }
          }
        });
      }
    }
    else if (adultrow.length > 1 && childrow.length == 1) {

      if ((adultnosupplier.length > 1 && adultsupplier.length == 0) && childrow[0].partycode != "") {

        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == 'Child as Adult') {
              this.excursiondeails.supplierList[i]['service_provider_id'] = "";
              this.excursiondeails.supplierList[i]['sp_name'] = "";
              this.excursiondeails.supplierList[i]['partycode'] == "";
              this.excursiondeails.supplierList[i]['partyname'] = "";
              this.excursiondeails.supplierList[i]['serviceStatus'] = 1;
            }
          }
        });

      }

    }
    else if (adultrow.length > 1 && childrow.length > 1) {

      if ((adultsupplier.length == 0 && adultnosupplier.length >= 1) && (childsupplier.length >= 1)) {

        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == 'Child as Adult') {
              this.excursiondeails.supplierList[i]['service_provider_id'] = "";
              this.excursiondeails.supplierList[i]['sp_name'] = "";
              this.excursiondeails.supplierList[i]['partycode'] == "";
              this.excursiondeails.supplierList[i]['partyname'] = "";
              this.excursiondeails.supplierList[i]['serviceStatus'] = 1;
            }
          }
        });

      }
      else if (adultsupplier.length == 1 && adultnosupplier.length >= 1) {

        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == 'Child as Adult') {
              this.excursiondeails.supplierList[i]['service_provider_id'] = adultsupplier[0].service_provider_id;
              this.excursiondeails.supplierList[i]['sp_name'] = adultsupplier[0].sp_name;
              this.excursiondeails.supplierList[i]['partycode'] == adultsupplier[0].partycode;
              this.excursiondeails.supplierList[i]['partyname'] = adultsupplier[0].sp_name;
              this.excursiondeails.supplierList[i]['serviceStatus'] = adultsupplier[0].serviceStatus;
            }
          }
        });
      }
    }
    else if(adultrow.length == 1 && childrow.length > 1){
      if(adultnosupplier.length == 1){
        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == 'Child as Adult') {
              this.excursiondeails.supplierList[i]['service_provider_id'] = "";
              this.excursiondeails.supplierList[i]['sp_name'] = "";
              this.excursiondeails.supplierList[i]['partycode'] == "";
              this.excursiondeails.supplierList[i]['partyname'] = "";
              this.excursiondeails.supplierList[i]['serviceStatus'] = 1;
            }
          }
        });
      }
      else if(adultsupplier.length == 1){
        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == 'Child as Adult') {
              this.excursiondeails.supplierList[i]['service_provider_id'] = adultsupplier[0].service_provider_id;
              this.excursiondeails.supplierList[i]['sp_name'] = adultsupplier[0].sp_name;
              this.excursiondeails.supplierList[i]['partycode'] == adultsupplier[0].partycode;
              this.excursiondeails.supplierList[i]['partyname'] = adultsupplier[0].sp_name;
              this.excursiondeails.supplierList[i]['serviceStatus'] = adultsupplier[0].serviceStatus;
            }
          }
        });
      }
    }
    else if(isXClick && (this.appClient == "Mayra" || this.appClient == "RoyalAdventure")){
      this.excursiondeails.supplierList.forEach((x: any, i: any) => {
        this.excursiondeails.supplierList[i]['service_provider_id'] = "";
        this.excursiondeails.supplierList[i]['sp_name'] = "";
        this.excursiondeails.supplierList[i]['partycode'] == "";
        this.excursiondeails.supplierList[i]['partyname'] = "";
        this.excursiondeails.supplierList[i]['serviceStatus'] = 1;
      }); 
    }
  }

  resetsupplier(idx: any, isXClick: boolean = true) {

    // let p_id = this.excursiondeails.supplierList[idx]['service_provider_id']
    // this.excursiondeails.supplierList.forEach((x: any, i: any) => {
    //   if ((i == idx || this.excursiondeails.supplierList[idx].cost[0].paxType == 'Child') && this.excursiondeails.supplierList[i]['service_provider_id'] == p_id) {
    //     // Modified by Ram 05-07-2023
    //   //if ((i == idx) && this.excursiondeails.supplierList[i]['service_provider_id'] == p_id) {
    //     this.excursiondeails.supplierList[i]['service_provider_id'] = ''
    //     this.excursiondeails.supplierList[i]['sp_name'] = ''
    //     // sp_name
    //     this.excursiondeails.supplierList[i]['partycode'] == ''
    //     this.excursiondeails.supplierList[i]['serviceStatus'] = 1
    //   }
    // });

    this.ResetSupplier_New(isXClick);

  }

  Check_Child_Supplier_New(){
    let status: boolean = true;

    var adultrow: any = [];
    adultrow = this.excursiondeails.supplierList.filter((r: any, index: any) => r.cost.length != 0 && r.cost[0].paxType == "Adult");
    var childrow: any = [];
    childrow = this.excursiondeails.supplierList.filter((r: any, index: any) => r.cost.length != 0 && (r.cost[0].paxType == "Child" || r.cost[0].paxType == "Child as Adult"));

    var adultnosupplier: any = [];
    adultnosupplier = adultrow.filter((r: any, index: any) => r.partycode == "");
    var childnosupplier: any = [];
    childnosupplier = childrow.filter((r: any, index:any) => r.partycode == "");

    var adultsupplier: any = [];
    adultsupplier = adultrow.filter((r: any, index: any) => r.partycode != "");
    var childsupplier: any = [];
    childsupplier = childrow.filter((r: any, index:any) => r.partycode != "");

    if(adultrow.length == 1 && childrow.length == 1){
      if((adultrow[0].partycode != "" && childrow[0].partycode == "") || 
          (adultrow[0].partycode == "" && childrow[0].partycode != "") ){

        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == "Child as Adult") {
              this.excursiondeails.supplierList[i]['service_provider_id'] = this.excursiondeails.supplierList[i - 1]['service_provider_id'];
              this.excursiondeails.supplierList[i]['sp_name'] = this.excursiondeails.supplierList[i - 1]['sp_name'];
              this.excursiondeails.supplierList[i]['partycode'] == this.excursiondeails.supplierList[i - 1]['partycode'];
              this.excursiondeails.supplierList[i]['serviceStatus'] = this.excursiondeails.supplierList[i - 1]['serviceStatus'];
              this.excursiondeails.supplierList[i]['partyname'] = this.excursiondeails.supplierList[i - 1]['sp_name'];
            }
          }
        });

        return status = true;
      }
      else if(adultrow[0].partycode == "" && childrow[0].partycode == ""){
        return status = true;
      }
    }
    else if(adultrow.length > 1 && childrow.length == 1){

      if ((adultnosupplier.length > 1 && adultsupplier.length == 0) && childrow[0].partycode == "") {
        return status = true;
      }
      else if ((adultsupplier.length > 1 && adultnosupplier.length == 0) && childrow[0].partycode == "") {
        return status = false;
      }
      else if ((adultsupplier.length > 1 && adultnosupplier.length >= 1) && childrow[0].partycode == "") {
        return status = false;
      }
      else if ((adultnosupplier.length > 1 && adultsupplier.length == 0) && childrow[0].partycode != "") {

        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == "Child as Adult") {
              this.excursiondeails.supplierList[i]['service_provider_id'] = "";
              this.excursiondeails.supplierList[i]['sp_name'] = "";
              this.excursiondeails.supplierList[i]['partycode'] == "";
              this.excursiondeails.supplierList[i]['serviceStatus'] = 1;
              this.excursiondeails.supplierList[i]['partyname'] = "";
            }
          }
        });

        return status = true;
      }

    }
    else if(adultrow.length > 1 && childrow.length > 1){

      if((adultnosupplier.length > 1 && adultsupplier.length == 0) 
          && (childnosupplier.length > 1 && childsupplier.length == 0)){
            return status = true;
      }
      else if(adultsupplier.length > 1 && childnosupplier.length > 1){
        return status = false;
      }
      else if(adultsupplier.length > 1 && childsupplier.length >= 1 && childnosupplier.length >= 1){
        return status = false;
      }
      else if((adultsupplier.length == 0 && adultnosupplier.length >= 1) && (childsupplier.length >= 1)){

        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == "Child as Adult") {
              this.excursiondeails.supplierList[i]['service_provider_id'] = "";
              this.excursiondeails.supplierList[i]['sp_name'] = "";
              this.excursiondeails.supplierList[i]['partycode'] == "";
              this.excursiondeails.supplierList[i]['serviceStatus'] = 1;
              this.excursiondeails.supplierList[i]['partyname'] = "";
            }
          }
        });

        return status = true;
      }
      else if(adultsupplier.length == 1 && adultnosupplier.length >= 1){

        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == "Child as Adult") {
              this.excursiondeails.supplierList[i]['service_provider_id'] = adultsupplier[0].service_provider_id;
              this.excursiondeails.supplierList[i]['sp_name'] = adultsupplier[0].sp_name;
              this.excursiondeails.supplierList[i]['partycode'] == adultsupplier[0].partycode;
              this.excursiondeails.supplierList[i]['serviceStatus'] = adultsupplier[0].serviceStatus;
              this.excursiondeails.supplierList[i]['partyname'] = adultsupplier[0].sp_name;
            }
          }
        });
      }

      return status = true;

    }
    else if(adultrow.length == 1 && childrow.length > 1){
      if(adultnosupplier.length == 1){
        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == "Child as Adult") {
              this.excursiondeails.supplierList[i]['service_provider_id'] = "";
              this.excursiondeails.supplierList[i]['sp_name'] = "";
              this.excursiondeails.supplierList[i]['partycode'] == "";
              this.excursiondeails.supplierList[i]['serviceStatus'] = 1;
              this.excursiondeails.supplierList[i]['partyname'] = "";
            }
          }
        });

        return status = true;
      }
      else if(adultnosupplier.length == 1 && childnosupplier.length >= 1 && childsupplier.length == 0){
        return status = true;
      }
      else if(adultsupplier.length == 1){
        this.excursiondeails.supplierList.forEach((x: any, i: any) => {
          if (x.cost.length != 0) {
            if (x.cost[0].paxType == "Child" || x.cost[0].paxType == "Child as Adult") {
              this.excursiondeails.supplierList[i]['service_provider_id'] = adultsupplier[0].service_provider_id;
              this.excursiondeails.supplierList[i]['sp_name'] = adultsupplier[0].sp_name;
              this.excursiondeails.supplierList[i]['partycode'] == adultsupplier[0].partycode;
              this.excursiondeails.supplierList[i]['serviceStatus'] = adultsupplier[0].serviceStatus;
              this.excursiondeails.supplierList[i]['partyname'] = adultsupplier[0].sp_name;
            }
          }
        });

        return status = true;
      }
    }

    return status = true;
  }

  check_child_supplier() {
    let status_chek = true
    //this.checkChildSupplier = true;
    this.excursiondeails.supplierList.forEach((x: any, i: any) => {
      if (x.cost.length != 0) {
        if (x.cost[0].paxType == 'Child' || x.cost[0].paxType == 'Child as Adult') {
          let li = this.excursiondeails.supplierList.filter((r: any, index: any) => r.service_provider_id == this.excursiondeails.supplierList[i]['partycode'] && index != i)
          //let li: any = [];
          //console.log(li);
          if (li.length == 0 || status_chek == false) {
            status_chek = false;
            //this.checkChildSupplier = false;

            // //Added by Ram 05-07-2023
            // var adultrow = [];
            // adultrow = this.excursiondeails.supplierList.filter((r: any, index: any) => r.cost[0].paxType=="Adult");
            // var childrow = [];
            // childrow = this.excursiondeails.supplierList.filter((r: any, index: any) => r.cost[0].paxType=="Child");

            // if(adultrow.length == 1 && childrow.length == 1){

            //   if(adultrow[0].service_provider_id == "" && childrow[0].service_provider_id == ""){
            //     status_chek = true;
            //     this.checkChildSupplier = true;
            //   }
            //   else if(adultrow[0].service_provider_id != "" && childrow[0].service_provider_id == ""){

            //     this.excursiondeails.supplierList.forEach((x: any, i: any) => {
            //       if(x.cost.length!=0){
            //         if(x.cost[0].paxType == "Child"){
            //           this.excursiondeails.supplierList[i]['service_provider_id'] = this.excursiondeails.supplierList[i-1]['service_provider_id'];
            //           this.excursiondeails.supplierList[i]['sp_name'] = this.excursiondeails.supplierList[i-1]['sp_name'];
            //           this.excursiondeails.supplierList[i]['partycode'] == this.excursiondeails.supplierList[i-1]['partycode'];
            //           this.excursiondeails.supplierList[i]['serviceStatus'] = this.excursiondeails.supplierList[i-1]['serviceStatus'];
            //         }
            //       }
            //     });

            //     status_chek = true;
            //     this.checkChildSupplier = true;

            //   }
            //   else if(adultrow[0].service_provider_id == childrow[0].service_provider_id){
            //     status_chek = true;
            //     this.checkChildSupplier = true;
            //   }
            //   else{
            //     status_chek = false;
            //     this.checkChildSupplier = false;
            //   }
            // }
            // else if(adultrow.length > 1 && childrow.length == 1){
            //   var adultemptycheck:any = [];
            //   adultemptycheck = adultrow.filter((r: any, index: any) => r.service_provider_id != "");

            //   var childemptycheck:any = [];
            //   childemptycheck = childrow.filter((r: any, index: any) => r.service_provider_id == "");

            //   if(adultemptycheck.length >= 1 && childemptycheck.length == 1){
            //     status_chek = false;
            //     this.checkChildSupplier = false;
            //   }
            //   else{
            //     status_chek = true;
            //     this.checkChildSupplier = true;
            //   }
            // }
            // //End

            return status_chek;
          }
          else {
            status_chek = false;
            //this.checkChildSupplier = false;
            //console.log(li)
            li.forEach((xs: any) => {
              if (xs.cost[0].paxType != 'Child' && xs.cost[0].paxType != 'Child as Adult') {
                status_chek = true;
                //this.checkChildSupplier = true;
                return status_chek;
                // return status_chek
              }
              else{
                return status_chek;
              }

            })
            // status_chek=false
            return status_chek;
          }
        }
        else {
          status_chek = true
          //this.checkChildSupplier = true;
          return status_chek;
        }
      } else {
        status_chek = true;
        //this.checkChildSupplier = true;
        return status_chek;
      }
    });
    return status_chek;
  }

  close_status() {
    if (this.status_list.length < 4) {
      this.status_list = []
      this.status_list = [{ 'id': 1, 'value': 'Pending' }, { 'id': 2, 'value': 'Assigned' }, { 'id': 3, 'value': 'Confirmed' }, { 'id': 5, 'value': 'Rejected' }]
    }
  }
  remove_list(idx: any) {

    // if (this.excursiondeails.supplierList[idx]['partycode'] != null && this.excursiondeails.supplierList[idx]['partycode'] != '' && this.excursiondeails.supplierList[idx]['service_provider_id'] != 'E/000041' && this.excursiondeails.supplierList[idx]['service_provider_id'] != 'T-000001') {

    //   this.status_list = [{ 'id': 2, 'value': 'Assigned' }, { 'id': 3, 'value': 'Confirmed' }, { 'id': 5, 'value': 'Rejected' }]
    //   console.log(this.status_list)
    // }

    if (this.excursiondeails.supplierList[idx]['partycode'] != null && this.excursiondeails.supplierList[idx]['partycode'] != '' && !this.defaultSupplierExists(this.excursiondeails.supplierList[idx]['service_provider_id'])) {

      this.status_list = [{ 'id': 2, 'value': 'Assigned' }, { 'id': 3, 'value': 'Confirmed' }, { 'id': 5, 'value': 'Rejected' }]
      //console.log(this.status_list)
    }

  }
  statcsChange(event: any, idx: any) {

    //if (this.excursiondeails.supplierList[idx]['service_provider_id'] != null && this.excursiondeails.supplierList[idx]['service_provider_id'] != '' && this.excursiondeails.supplierList[idx]['service_provider_id'] != 'E/000041' && this.excursiondeails.supplierList[idx]['service_provider_id'] != 'T-000001') 
    if (this.excursiondeails.supplierList[idx]['service_provider_id'] != null && this.excursiondeails.supplierList[idx]['service_provider_id'] != '' && !this.defaultSupplierExists(this.excursiondeails.supplierList[idx]['service_provider_id'])) 
    {
      if (event.id == 1) {
        event.id = 2
        this.excursiondeails.supplierList[idx]['serviceStatus'] = 3
        this.toastrService.error('Assiged Supplier', 'Title Error!', { closeButton: true, timeOut: 3000 });
      }
    }
    else {
      this.status_list = []
      this.status_list = [{ 'id': 1, 'value': 'Pending' }, { 'id': 2, 'value': 'Assigned' }, { 'id': 3, 'value': 'Confirmed' }, { 'id': 4, 'value': 'Rejected' }]
      this.excursiondeails.supplierList[idx]['serviceStatus'] = 1
    }
  }
  onSampleChange(event: any) {
    //console.log(event)
  }
  viewdetails(data: any) {
    this.setActiveItem("supplier")
    this.activeItem = this.items[0];
    this.loadexcursiondetails(data)
  }

  showCopyDetails(data: any){
    //console.log('show copy clicked');
    this.CopyDetails = true;
    this.CopyDetailsData = data;
    this.CopyText = "Request Id";
  }

  // CopyDetailsClick(data: any){
  //   //this.CopyText = "Text copied";
  //   this.CopyText.Select();
  //   document.execCommand('copy');
  // }

  // ngAfterViewInit(): void {
  //   //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
  //   //Add 'implements AfterViewInit' to the class.

  // }
  locations: any = []
  keyword = 'partyname'
  getsum(li: any, price: any, paxtye: any) {
    if (paxtye == 'Adult') {
      // adultprice=0
      // li.forEach(element => {

      // });
    }

  }



  searchlocation(data: any) {

    this.excursionServiceService.search_loaction({ 'text_add': data.value }).subscribe((res: { [x: string]: any; }) => {
      this.locations = res['data']
    });
  }
  locatin_pickup = []
  searchlocation_pickup(data: any) {

    this.excursionServiceService.search_loaction_hotel(this.excursionForm.value).subscribe((res: { [x: string]: any; }) => {
      this.locatin_pickup = res['data']
    });
  }
  selectedMessage: any;

  ngOnInit(): void {
    // this.clicktoload({})

    window.setTimeout(() => {
      // console.log('setting focus now');
      this.calendar.inputfieldViewChild.nativeElement.focus();
      this.calendar.toggle()

    }, 10);
    this.data_service.currentMessage.subscribe(message => (this.selectedMessage = message

    ))
    //console.log(this.selectedMessage)
    if (this.selectedMessage.hasOwnProperty('form')) {
      //console.log(this.selectedMessage)
      this.excursionForm.patchValue({
        request_from_date: this.selectedMessage['form'].request_date_from == '' ? '' : this.selectedMessage['form'].request_date_from == null ? '' : new Date(this.selectedMessage['form'].request_date_from),
        request_to_date: this.selectedMessage['form'].request_date_to == '' ? '' : this.selectedMessage['form'].request_date_to == null ? '' : new Date(this.selectedMessage['form'].request_date_to),
        excursion_from_date: this.selectedMessage['form'].transfer_date_from == '' ? '' : this.selectedMessage['form'].transfer_date_from == null ? '' : new Date(this.selectedMessage['form'].transfer_date_from),

        excursion_to_date: this.selectedMessage['form'].transfer_date_to == '' ? '' : this.selectedMessage['form'].transfer_date_to == null ? '' : new Date(this.selectedMessage['form'].transfer_date_to),
        status: this.selectedMessage['status'] != 6 ? this.selectedMessage['status'] : '',
        amendment: this.selectedMessage['status'] == 6 ? 1 : ''
      })
      // this.loadexcursion(this.excursionForm.value);
    }
    console.log(this.excursionForm);
    //else{
    //   this.loadclasifications();
    // }
    // this.messageService.add({key: 'c', sticky: true, severity:'warn', summary:'Are you sure?', detail:'Confirm to proceed'});
    this.items = [
      {
        label: 'Supplier', icon: 'pi pi-fw pi-pencil', command: (event) => {
          this.setActiveItem("supplier")
        }
      },
      {
        label: 'Pickup Time & Location', icon: 'pi pi-fw pi-pencil', command: (event) => {
          this.setActiveItem("location")
        }
      },
      {
        label: 'Remarks', icon: 'pi pi-fw pi-pencil', command: (event) => {
          this.setActiveItem("remarks")
        }
      },
      {
        label: 'Confirmations Details', icon: 'pi pi-fw pi-pencil', command: (event) => {
          this.setActiveItem("confirmations")
        }
      },
      {
        label: 'History', icon: 'pi pi-fw pi-file', command: (event) => {
          this.setActiveItem("history")
        }
      }


    ];
    this.activeItem = this.items[0];
    const data = {}
    if(this.appClient == "RoyalPark"){
      this.excursionForm.patchValue({
        order_by: 5,
      })
    }

    this.loadexcursion(this.excursionForm.value, true);

    // this.loaddashboard(data)
    // this.searchElement.nativeElement.focus();
    const excPIndex = localStorage.getItem('excursionPageIndex');
    //console.log(excPIndex);
    if (excPIndex == undefined) {
      this.excursionPageIndex = 0;
    } else {
      this.excursionPageIndex = Number(excPIndex);
    }
    // this.excursionPageIndex = Number(excPIndex);
    localStorage.setItem('excursionPageIndex', "1");
  }

  ngAfterViewInit() {
    //   window.setTimeout(() => {
    //     // console.log('setting focus now');
    //     this.calendar.inputfieldViewChild.nativeElement.focus();
    // }, 10);
    // setTimeout(()=>{ // this will make the execution after the above boolean has changed
    //   this.searchElement.nativeElement.focus();
    // },10);

    const cUrl = this.router.url;
    //console.log(cUrl);

    if(this.appClient == "RoyalPark"){
      this.excursionForm.patchValue({
        order_by: 5,
      })
    }

  }

  numberOnly(event: any): boolean {

    // console.log(event.target.value)
    // console.log(event.target.value.includes(':'))

    if (event.target.value.length > 4) {
      return false
    }
    if (event.key == ':') {
      return true
    }
    let key = Number(event.key)
    return !isNaN(key);
  }
  nuberchange(event: any): boolean {
    // hoursOnly(event): boolean {
    //console.log(event.target.value)
    if (event.target.value.includes(':')) {
      let i = event.target.value.split(':')
      let tim = parseInt(i[0])
      if (parseInt(i[0]) > 24) {
        event.target.value = '00:' + i[1]
      }
      if (parseInt(i[1]) >= 60) {
        event.target.value = i[0] + ':00'
      }
    }
    else {
      if (event.target.value.length > 2) {
        event.target.value = '0'
      }
      if (parseInt(event.target.value) > 24) {
        event.target.value = '0'
      }


    }
    let val = event.target.value
    let key = Number(event.key)
    let isAllowColon = (val.search(':') == -1)
    return !isNaN(key) || (event.key === ':' && isAllowColon);
    // }
  }
  load_menu() {
    this.items = [
      {
        label: 'Supplier', icon: 'pi pi-fw pi-pencil', command: (event) => {
          this.setActiveItem("supplier")
        }
      },
      {
        label: 'Pickup Time & Location', icon: 'pi pi-fw pi-pencil', command: (event) => {
          this.setActiveItem("location")
        }
      },
      {
        label: 'Remarks', icon: 'pi pi-fw pi-pencil', command: (event) => {
          this.setActiveItem("remarks")
        }
      },
      {
        label: 'Confirmations Details', icon: 'pi pi-fw pi-pencil', command: (event) => {
          this.setActiveItem("confirmations")
        }
      },
      {
        label: 'History', icon: 'pi pi-fw pi-file', command: (event) => {
          this.setActiveItem("history")
        }
      }


    ]
  }

  setActiveItem(ite: any) {
    //////console.log(ite)
    this.menutitle = ite
  }
  first = 0
  loadexcursion(data: any, isPageLoad: boolean = false){
    this.loading = true
    // let va=Object.assign({}, data);
    let va = { ...data };
    // if (data['excursion_pickuplocation']!=''&& data['excursion_pickuplocation'] !=null){
    //   va['excursion_pickuplocation']=data['excursion_pickuplocation'].partycode.split(';')[0]
    // }
    //console.log(va);
    this.excursionServiceService.getexcursion_list(va).subscribe((res: any) => {
      //console.log(new Date())
      this.loading = false
      if (res['result'] == 1) {
        this.first = 0
        this.excursionlist = []
        this.excursionlist = res['data'][0]['ExcursionList'];
        let excelList:any = [];
        excelList = res['data'][0]['ExcelexportList'];
        this.ex_total_adult = this.excursionlist.reduce((sum: any, current: any) => sum + (+current.adults), 0);
        this.ex_total_unit = this.excursionlist.reduce((sum: any, current: any) => sum + (+current.units), 0);
        this.ex_total_child = this.excursionlist.reduce((sum: any, current: any) => sum + (+current.child), 0);
        this.loadclasifications();
        //////console.log(this.excursionlist)

        // this.loadsupplierdetails({})
        this.excursionlist_export = [];
        this.getExcursiondataForExport(excelList);
      }
      else if(res['result'] == 0 && isPageLoad == false){
        var msg = res['errors'];
        this.toastrService.error(msg, 'Title Error!', { closeButton: true, timeOut: 3000 });
      }
    }


    );
    // this.loading=false
  }
  loadexcursion_refers(data: {}) {
    this.loading = true
    this.excursionServiceService.getexcursion_list(data).subscribe((res: any) => {
      //console.log(new Date())
      this.loading = false
      if (res['result'] == 1) {
        this.excursionlist = res['data'][0]['ExcursionList'];
        let excelList:any = [];
        excelList = res['data'][0]['ExcelexportList'];
        //this.excursionlist = res['data']
        // this.loadclasifications();
        //////console.log(this.excursionlist)

        // this.loadsupplierdetails({})

      }
    }


    );
    // this.loading=false
  }

  provider_history = []
  amend_history = []
  confirmation_list: any = []
  total = 0

  remarks_list: any = []
  selectEvent(data: any) {
    this.excursionForm.patchValue({ 'excursion_pickuplocation': data.partyname })

  }
  cost_list: any = []
  multi_dummy_list: any = []
  currrates_list: any = []
  loadexcursiondetails(data: any = {}) {

    this.excursionServiceService.getexcursion_Details(data).subscribe((res: any) => {
      if (res['result'] == 1) {
        this.excursionServiceService.getexcursionHistory_Details({ 'requestid': data.requestid }).subscribe(resp => {

          this.excursionServiceService.getexcursionLocation_Details({ 'requestid': data.requestid, 'elineno': data.elineno, 'service_id': data.service_ref_id }).subscribe(resp_location => {

            if (resp_location['result'] == 1) {
              this.location_list = resp_location['data']
            }
          });
          if (res['result'] == 1) {

            this.provider_history = resp['data'][0]['allocation'];
            this.amend_history = resp['data'][0]['amendment'];
          }
        })
        this.excursiondeails = res['data'][0]  //service List

        if(this.appClient == "RoyalPark"){
          this.currrates_list = res['data'][0]['currrates'];

          let filteredCurrRates: any[] =  this.currrates_list.filter((item: { currcode: string;tocurr: string; }) => item.currcode === this.excursiondeails.sellingCurrency && item.tocurr === this.excursiondeails.baseCurrency);

          //this.excursiondeails.baseCurrtotalsalevalue = 0;

          if(filteredCurrRates.length > 0 && this.excursiondeails.baseCurrtotalsalevalue == 0){
            this.excursiondeails.baseCurrtotalsalevalue = this.excursiondeails.maxtotalsalevalue * filteredCurrRates[0]['convrate'];
          }
          // else{
          //   this.excursiondeails.baseCurrtotalsalevalue = this.excursiondeails.maxtotalsalevalue;
          // }
        }

        // let len_th=this.excursiondeails['supplierList'].filter((r:any)=>r.service_id=this.excursiondeails.service_ref_id && r.is_parent==1)
        // if (this.excursiondeails['supplierList'])

        //Commented by Ram 11-07-2023

        // if (this.excursiondeails.is_multicost == 1) {

        //   this.multi_dummy_list = JSON.parse(JSON.stringify(res['data'][0]['supplierList']))
        //   console.log(this.multi_dummy_list)
        // }

        //End commented

        this.confirmation_list = []
        //supplier loop
        //console.log('supplier loop start');
        for (var i = 0; i < this.excursiondeails['supplierList'].length; i++) {
          this.excursiondeails['supplierList'][i].child_list = this.excursiondeails['supplierList'].filter((r: any) => r.service_id == this.excursiondeails['supplierList'][i].service_id && r.rownumber != this.excursiondeails['supplierList'][i].rownumber)
          this.excursiondeails['supplierList'][i].notification_li = 'not required' //email send

          if (this.excursiondeails.supplierList[i]['cost'] && this.excursiondeails.is_multicost == 0) //single cost
          {
            this.cost_list = this.excursiondeails.supplierList[i].cost.filter((r: any) => (r.paxType == 'Child' || r.paxType == 'Child as Adult')) //child list


            if (this.cost_list.length > 1) {
              //without child
              this.excursiondeails.supplierList[i].cost = this.excursiondeails.supplierList[i].cost.filter((r: any) => (r.paxType != 'Child' && r.paxType != 'Child as Adult'))

              for (var j = 0; j < this.cost_list.length; j++) {
                if (j == 0) {
                  this.excursiondeails.supplierList[i].cost.push(this.cost_list[j])
                }
                else {
                  // let va=Object.assign({}, this.excursiondeails.supplierList[i]); 
                  let va = { ...this.excursiondeails.supplierList[i] };
                  va.close = 'yes'
                  va.adults = 0
                  va.child = this.cost_list[j]['noofPaxOrUnit']
                  va.inx = i
                  va.senior = 0
                  va.paxType = this.cost_list[j]['paxType']
                  va.service_id = 0
                  va.cost = []
                  va.cost.push(this.cost_list[j])
                  this.excursiondeails.supplierList.splice(i + 1, i, va)
                  //  this.excursiondeails.supplierList.push(va)
                }
                //console.log(this.excursiondeails.supplierList)

                // this.totoal_child=this.totoal_child+this.cost_list[j].noofPaxOrUnit

                //  this.excursiondeails.supplierList.splice(rowIndex+1,rowIndex,va)

              }

            } else {
              if (this.excursiondeails['supplierList'][i].cost.length != 0 ? (this.excursiondeails['supplierList'][i].cost[0].paxType == 'Child' || this.excursiondeails['supplierList'][i].cost[0].paxType == 'Child as Adult') : false) {
                this.excursiondeails['supplierList'][i].serviceStatus = 3
              }

            }
          }

          if (this.excursiondeails.supplierList[i]['cost'] && this.excursiondeails.is_multicost == 1) //multi cost
          {
            this.cost_list = this.excursiondeails.supplierList[i].cost.filter((r: any) => (r.paxType == 'Child' || r.paxType == 'Child as Adult')) // child list
            
            if (this.cost_list.length > 1) {
              //without child list
              this.excursiondeails.supplierList[i].cost = this.excursiondeails.supplierList[i].cost.filter((r: any) => (r.paxType != 'Child' && r.paxType != 'Child as Adult'))
              //console.log(this.excursiondeails.supplierList[i].cost);

              for (var j = 0; j < this.cost_list.length; j++) {
                // let va=Object.assign({}, this.excursiondeails.supplierList[i]); 
                let va = { ...this.excursiondeails.supplierList[i] };
                va.close = 'yes'
                va.inx = i
                if (j == 0) {
                  this.excursiondeails.supplierList[i].cost.push(this.cost_list[j]);
                } else {
                  // va.service_id=0
                  va.adults = 0
                  va.child = this.cost_list[j]['noofPaxOrUnit']
                  va.paxType = this.cost_list[j]['paxType']
                  va.inx = i
                  va.senior = 0
                  va.service_id = 0
                  va.cost = []
                  va.cost.push(this.cost_list[j])
                  //this.excursiondeails.supplierList.splice(i + 1, i, va) // Commented by Ram 11-07-2023
                  this.excursiondeails.supplierList.splice(i + 1, 0, va) // Added by Ram 11-07-2023
                }
                //console.log(this.excursiondeails.supplierList);
                // this.excursiondeails.supplierList.push(va)
                //  this.excursiondeails.supplierList.splice(rowIndex+1,rowIndex,va)
              }
            }
          }

          // const confirmation_va={
          //   'requestid':this.excursiondeails['supplierList'][i]['requestid'],
          //   'excdate':this.excursiondeails['supplierList'][i]['excdate'],
          //   'service name':this.excursiondeails['supplierList'][i]['service_name'],
          //   'sp_name':this.excursiondeails['supplierList'][i]['sp_name'],
          //   'confirmation_id':'',
          //   'file_attachment':'',

          // }
          // //////console.log(confirmation_va)
          //**location load */

          // this.location_list.push(
          //   {
          //     'requestid':this.excursiondeails['supplierList'][i]['requestid'],
          //     'excdate':this.excursiondeails['supplierList'][i]['excdate'],
          //     'service_id':this.excursiondeails['supplierList'][i]['service_id'],
          //     'service_name':this.excursiondeails['supplierList'][i]['sm_name'],
          //     'sp_name':this.excursiondeails['supplierList'][i]['sp_name'],
          //     'confirmid':'',
          //     'file':'',
          //     'eline':this.excursiondeails['supplierList'][i]['elineno'],
          //     'service_provider_id':this.excursiondeails['supplierList'][i]['service_provider_id'],
          //     'is_parent':this.excursiondeails['supplierList'][i]['is_parent']

          //   }

          // )

          this.confirmation_list.push({
            'requestid': this.excursiondeails['supplierList'][i]['requestid'],
            'excdate': this.excursiondeails['supplierList'][i]['excdate'],
            'service_id': this.excursiondeails['supplierList'][i]['service_id'],
            'service_name': this.excursiondeails['supplierList'][i]['sm_name'],
            'sp_name': this.excursiondeails['supplierList'][i]['sp_name'],
            //'confirmid': this.excursiondeails['confirmationid'],
            //'confirmation_id': this.excursiondeails['confirmationid'],
            'confirmation_id': this.excursiondeails['supplierList'][i]['confirmationid'],
            'file': '',
            'eline': this.excursiondeails['supplierList'][i]['elineno'],
            'service_provider_id': this.excursiondeails['supplierList'][i]['service_provider_id'],
            'is_parent': this.excursiondeails['supplierList'][i]['is_parent'],
            'is_multicost': this.excursiondeails['supplierList'][i]['is_multicost']

          })
          //console.log(this.confirmation_list)
        }
        //loop End

        // this.confirmation_list=res['data'][0]
        this.menutitle = 'supplier'
        this.displayPosition = true
        this.remarks_list = [] //remark list
        if (this.excursiondeails.remarks.length != 0) //remark push
        {
          this.remarks_list.push(this.excursiondeails.remarks[0])
        } else {
          this.remarks_list.push({
            'requestid': this.excursiondeails.requestid,
            'service_name': this.excursiondeails.servicelist,
            'rlineno': this.excursiondeails.elineno,
            'excdate': this.excursiondeails.excdate,
            'agentremarks': '',
            'Partyremarks': '',
            'arrivalremarks': '',
            'departureremarks': '',

          })
        }
        //console.log(this.remarks_list)
        this.excursiondeails.supplierList.forEach((res: any, index: any) => {
          // if (this.excursiondeails.supplierList[index].is_parent!=1){
          //comp_cust set
          this.excursiondeails.supplierList[index].comp_cust = this.excursiondeails.supplierList[index].comp_cust == null ? 0 : this.excursiondeails.supplierList[index].comp_cust
          if (this.excursiondeails.supplierList[index].service_provider_id == undefined) {
            this.excursiondeails.supplierList[index].service_provider_id = this.excursiondeails.supplierList[index].partycode
          }
          //flag for cost
          this.excursiondeails.supplierList[index].cost_adult = false
          this.excursiondeails.supplierList[index].cost_child = false
          this.excursiondeails.supplierList[index].cost_senior = false
          this.excursiondeails.supplierList[index].cost_unit = false

          this.excursiondeails.supplierList[index].cost.forEach((cos: any, indexs: any) => {
            if (this.cost_adult == false) {
              this.cost_adult = cos.paxType == 'Adult' ? true : this.cost_adult
            }
            if (this.cost_child == false) {
              this.cost_child = (cos.paxType == 'Child' || cos.paxType == 'Child as Adult') ? true : this.cost_child
            }
            if (this.cost_senior == false) {
              this.cost_senior = cos.paxType == 'Senior' ? true : this.cost_senior
            }


            // this.cost_senior=cos[indexs].paxType=='Senior'?true:this.cost_senior
            if (cos.paxType == 'Adult') {
              this.excursiondeails.supplierList[index].cost_adult = true
            }
            if (cos.paxType == 'Child' || cos.paxType == 'Child as Adult') {
              this.excursiondeails.supplierList[index].cost_child = true
            }
            if (cos.paxType == 'Senior') {
              this.excursiondeails.supplierList[index].cost_senior = true
            }
            if (cos.paxType == 'Unit') {
              this.excursiondeails.supplierList[index].cost_unit = true
            }



            // console.log(this.excursiondeails.supplierList)



          });

          //Added by Ram 11-07-2023
          if (this.excursiondeails.is_multicost == 1) {

            //this.multi_dummy_list = JSON.parse(JSON.stringify(res['data'][0]['supplierList']))
            this.multi_dummy_list = JSON.parse(JSON.stringify(this.excursiondeails.supplierList));
            //console.log(this.multi_dummy_list)
          }
          //End

          //console.log(index)
          this.items = []
          this.load_menu()
          this.setActiveItem('supplier')
          this.activeItem = this.items[0]

        });


      }

    }

    );
  }
  getSum(data: any, i: any) {
    // console.log(data)
    let sum = 0
    if (data != undefined) {
      data.forEach((res: any, index: any) => {
        sum = sum + res.costValue
      })
    }
    // else{

    // }
    this.excursiondeails.supplierList[i].unitcostvalue = sum
    return sum
  }

  replace_old(inx: any, data: any) {
    if (this.excursiondeails.is_multicost == 1) {
      this.excursiondeails.supplierList.forEach((s_res: any, index: any) => {
        //console.log(inx)
        //console.log(index)
        if (this.multi_dummy_list[index].service_id != this.excursiondeails.supplierList[inx].service_id) {
          // this.excursiondeails.supplierList[index].cost={...this.multi_dummy_list[index].cost}
          //console.log(this.multi_dummy_list[index].cost)
          if (this.excursiondeails.supplierList[index].cost.length == 1) {
            this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) - (+this.excursiondeails.supplierList[index].cost[0].costValue)
            this.excursiondeails.supplierList[index].cost[0].paxOrUnitRate = this.multi_dummy_list[index].cost[0].paxOrUnitRate
            this.excursiondeails.supplierList[index].cost[0].costValue = this.multi_dummy_list[index].cost[0].noofPaxOrUnit * this.multi_dummy_list[index].cost[0].paxOrUnitRate
            this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) + (+this.multi_dummy_list[index].cost[0].costValue)
          }
          else if (this.excursiondeails.supplierList[index].cost.length > 1) {
            this.excursiondeails.supplierList[index].cost.forEach((s_res: any, index1: any) => {
              this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) - (+this.excursiondeails.supplierList[index].cost[index1].costValue)
              this.excursiondeails.supplierList[index].cost[index1].paxOrUnitRate = this.multi_dummy_list[index].cost[index1].paxOrUnitRate
              this.excursiondeails.supplierList[index].cost[index1].costValue = this.multi_dummy_list[index].cost[index1].noofPaxOrUnit * this.multi_dummy_list[index].cost[index1].paxOrUnitRate
              this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) + (+this.multi_dummy_list[index].cost[index1].costValue)
            });

          }
        }
      })
    }
    // this.excursiondeails.supplierList.filter((r:any))
  }

  adultchange_forSupCost(cost: number, i:any, rw: any){
    let filteredCurrRates: any = [];
    let convrates: number = 1;

    if(this.appClient == "RoyalPark"){
      if(this.excursiondeails.baseCurrency != this.excursiondeails.supplierList[rw].currcode){
        filteredCurrRates =  this.currrates_list.filter((item: { currcode: string;tocurr: string; }) => item.currcode === this.excursiondeails.supplierList[rw].currcode && item.tocurr === this.excursiondeails.baseCurrency);
      }
  
      if(filteredCurrRates.length > 0){
        convrates = filteredCurrRates[0]['convrate'];
      }
    }

    this.replace_old(rw, cost)
    this.excursiondeails.supplierList[rw].cost[i].paxOrUnitRate = +cost
    this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) - (+this.excursiondeails.supplierList[rw].cost[i].costValue)
    this.excursiondeails.supplierList[rw].cost[i].costValue = this.excursiondeails.supplierList[rw].cost[i].noofPaxOrUnit * cost
    
    if(this.appClient != "RoyalPark"){
      this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) + (+this.excursiondeails.supplierList[rw].cost[i].costValue)
    }
    else if(this.appClient == "RoyalPark"){
      this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) + ((+this.excursiondeails.supplierList[rw].cost[i].costValue) * convrates)
    }
  }

  adultchange(data: any, i: any, rw: any) {
    //////console.log(i)
    //////console.log(rw)
    //////console.log(data.value)
    let filteredCurrRates: any = [];
    let convrates: number = 1;

    if(this.appClient == "RoyalPark"){
      if(this.excursiondeails.baseCurrency != this.excursiondeails.supplierList[rw].currcode){
        filteredCurrRates =  this.currrates_list.filter((item: { currcode: string;tocurr: string; }) => item.currcode === this.excursiondeails.supplierList[rw].currcode && item.tocurr === this.excursiondeails.baseCurrency);
      }
  
      if(filteredCurrRates.length > 0){
        convrates = filteredCurrRates[0]['convrate'];
      }
    }

    this.replace_old(rw, data)
    this.excursiondeails.supplierList[rw].cost[i].paxOrUnitRate = +data.value
    this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) - (+this.excursiondeails.supplierList[rw].cost[i].costValue)
    this.excursiondeails.supplierList[rw].cost[i].costValue = this.excursiondeails.supplierList[rw].cost[i].noofPaxOrUnit * data.value
    
    if(this.appClient != "RoyalPark"){
      this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) + (+this.excursiondeails.supplierList[rw].cost[i].costValue)
    }
    else if(this.appClient == "RoyalPark"){
      this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) + ((+this.excursiondeails.supplierList[rw].cost[i].costValue) * convrates)
    }

    console.log('Line number 1641');
    console.log(this.excursiondeails.totalcostvalue);
  }

  countchange(data: any, i: any, rw: any, typs: any) {
    // let typechck=this.excursiondeails.supplierList[rw].cost.filter((s:any)=>s.paxType==typs)
    // if (i!=0 && typechck.length!=0){
    this.excursiondeails.supplierList[rw].cost[i].noofPaxOrUnit = data.value
    this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) - (+this.excursiondeails.supplierList[rw].cost[i].costValue)
    this.excursiondeails.supplierList[rw].cost[i].costValue = this.excursiondeails.supplierList[rw].cost[i].paxOrUnitRate * data.value
    this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) + (+this.excursiondeails.supplierList[rw].cost[i].costValue)
    this.excursiondeails.supplierList[rw].adults = 0
    this.excursiondeails.supplierList[rw].adults = parseInt(this.excursiondeails.supplierList[rw].cost.filter((r: any) => r.paxType == 'Adult').reduce((sum: any, item: any) => sum + item.noofPaxOrUnit, 0))
    this.excursiondeails.supplierList[rw].child = parseInt(this.excursiondeails.supplierList[rw].cost.filter((r: any) => r.paxType == 'Child' || r.paxType == 'Child as Adult').reduce((sum: any, item: any) => sum + item.noofPaxOrUnit, 0))
    this.excursiondeails.supplierList[rw].senior = this.excursiondeails.supplierList[rw].cost.filter((r: any) => r.paxType == 'senior').reduce((sum: any, item: any) => sum + item.noofPaxOrUnit, 0)
    // }
    //       else{
    //         let obj={childAge:7,
    // childasfree:0,
    // costValue:0,
    // elineno:this.excursiondeails.supplierList[rw].elineno,
    // freecount:0,
    // noofPaxOrUnit:data.value,
    // paxOrUnitRate:0,
    // paxType:typs,
    // rateType:this.excursiondeails.supplierList[rw].rateType,
    // requestid:this.excursiondeails.supplierList[rw].requestid,
    // serviceName:this.excursiondeails.supplierList[rw].sm_name,
    // }
    // if(this.excursiondeails.supplierList[rw].cost.length!=0){
    //   this.excursiondeails.supplierList[rw].cost.push(obj)
    // }else{
    //   this.excursiondeails.supplierList[rw].cost=[obj]
    // }
    // let va=Object.assign({}, this.excursiondeails); 
    // this.excursiondeails=[]
    // this.excursiondeails=va

    //       }
  }
  loadclasifications() {
    this.excursionServiceService.Classificationlist().subscribe(res => {
      if (res['result'] == 1) {
        this.classificationlist = res['data'];
        this.selectAllForDropdownItems(this.classificationlist);
        this.loadexcursiontype();
      }

    });
  }
  add_row(data: any, rowIndex: any) {
    // console.log(data);
    // console.log(rowIndex);
    if (data.PI_supplier == "0") { // this.excursiondeails.PI_supplier == null Condition changed by Ram 18-10-2023
      // data['close']='yes'
      // let va=Object.assign({}, data); 
      let va = { ...data }
      va.close = 'yes'
      va.service_id = 0
      va.inx = rowIndex
      va.service_provider_id = ''
      va.partycode = ''
      va.adults = 0
      let cost_li = va.cost;
      // va.cost=[{childAge:7,
      //   childasfree:0,
      //   costValue:0,
      //   elineno:this.excursiondeails.supplierList[rowIndex].elineno,
      //   freecount:0,
      //   noofPaxOrUnit:0,
      //   paxOrUnitRate:0,
      //   paxType:"Adult",
      //   rateType:"ACS",
      //   requestid:this.excursiondeails.supplierList[rowIndex].requestid,
      //   serviceName:this.excursiondeails.supplierList[rowIndex].sm_name},{childAge:7,
      //     childasfree:0,
      //     costValue:0,
      //     elineno:this.excursiondeails.supplierList[rowIndex].elineno,
      //     freecount:0,
      //     noofPaxOrUnit:0,
      //     paxOrUnitRate:0,
      //     paxType:"Child",
      //     rateType:"ACS",
      //     requestid:this.excursiondeails.supplierList[rowIndex].requestid,
      //     serviceName:this.excursiondeails.supplierList[rowIndex].sm_name}]
      va.cost = []
      // va.child_list=[]
      va.child = 0
      va.senior = 0
      va.adultprice = 0
      va.childcprice = 0
      va.seniorprice = 0
      va.units = 0
      va.unitprice = 0
      va.is_parent = 0
      va.serviceStatus = 1
      va.rownumber = (+va.rownumber) + 1
      va.partycode = ''
      va.sp_name = ''
      va.unitcostvalue = 0


      for (var j = 0; j < cost_li.length; j++) {
        // let new_va=Object.assign({}, cost_li[j])
        let new_va = { ...cost_li[j] }
        data
        new_va.paxOrUnitRate = 0
        new_va.noofPaxOrUnit = 0
        new_va.costValue = 0
        va.cost.push(new_va)
        // this.excursiondeails.supplierList.push(va)
        //  this.excursiondeails.supplierList.splice(rowIndex+1,rowIndex,va)

      }
      let len = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.service_ref_id == va.service_ref_id).length
      if (len != 0) {
        this.excursiondeails.supplierList.splice((len - 1) + 1, rowIndex, va)
        this.excursiondeails.supplierList[len - 1].child_list = []
      }

      else {
        // let len=this.excursiondeails.supplierList.filter((s:any)=>s.is_parent==1 && s.service_ref_id==va.service_ref_id).length
        this.excursiondeails.supplierList.splice(rowIndex + 1, rowIndex, va)
        this.excursiondeails.supplierList[rowIndex + 1].child_list = []
      }
      //  this.excursiondeails.supplierList=this.excursiondeails.supplierList.filter((s:any)=>s.cost[0].paxType!='Child')
      // this.excursiondeails.supplierList=this.excursiondeails.supplierList.filter((s:any)=>s.child_list.filter((r:any)=>(s.cost.push(r.cost[0]))))
      this.excursiondeails.supplierList = this.excursiondeails.supplierList.filter((s: any) => s.child_list = [])
      //console.log(this.excursiondeails.supplierList)
      let data_se = { "requestid": data['requestid'], "jsonval": this.excursiondeails.supplierList.filter((s: any) => s.service_ref_id == va.service_ref_id), 'elineno': data.elineno, 'row_count': +(rowIndex) + 1 }
      console.log(data_se);
      this.excursionServiceService.update_multiple_excursion(data_se).subscribe(resp => {
        let ex_data = { 'requestid': data['requestid'], 'service_ref_id': data['service_ref_id'], 'service_type': data['service_type'], 'is_multicost': data['is_multicost'], 'elineno': data['elineno'], 'is_multidate': data['is_multidate'], 'servicelist': this.excursiondeails.servicelist }
        // this.excursionServiceService.getexcursion_Details(ex_data).subscribe((res:any)=>{
        //   this.dt.reset()
        //   this.excursiondeails.supplierList=[]
        //   this.excursiondeails.supplierList=res['data'][0].supplierList
        // });
        this.loadexcursiondetails(ex_data)
      })

      //////console.log(this.excursiondeails)
      // this.excursiondeails.supplierList.push({
      //   'BookingMode':data.BookingMode,'CostTaxableValue':data.CostTaxableValue,'CostVATPerc':data.CostVATPerc,
      //   'CostVATValue':data.CostVATValue,'CostWithTax':data.CostWithTax,'PriceTaxableValue':data.PriceTaxableValue,
      //   'PriceVATPerc':data.PriceVATPerc,'PriceVATValue':data.PriceVATValue,'PriceWithTax':data.PriceWithTax,
      //   'adultcostvalue':data.adultcostvalue,'adultcplistcode':data.adultcplistcode,'adultcprice':data.adultcprice,
      //   'adulteplistcode':data.adulteplistcode,'adultprice':data.adultprice,'adults':data.adults,
      //   'adultsalevalue':data.adultsalevalue,'child':data.child,'childages':data.childages,'childasadult':data.childasadult,
      //   'childasadultcostvalue':data.childasadultcostvalue,'childasadultcprice':data.childasadultcprice,
      //   'childasadultprice':data.childasadultprice,'childasadultvalue':data.childasadultvalue,'childasfree':data.childasfree,
      //   'childasfreeages':data.childasfreeages,'childcostvalue':data.childcostvalue,'childcplistcode':data.childcplistcode,
      //   'childcprice':data.childcprice,'childeplistcode':data.childeplistcode,'childprice':data.childprice,
      //   'childsalevalue':data.childsalevalue,'classificationcode':data.classificationcode,
      //   'classificationname':data.classificationname,'coments':data.coments,
      //   'comp_cust':data.comp_cust,'criticality':data.criticality,'drop_offtime':data.drop_offtime,
      //   'elineno':data.elineno,'exc_endtime':data.exc_endtime,'exc_starttime':data.exc_starttime,
      //   'excdate':data.excdate,'exctypcode':data.exctypcode,'from_zone_id':data.from_zone_id,'is_mc_row':data.is_mc_row,
      //   'is_multicost':data.is_multicost,'is_multidate':data.is_multidate,'is_parent':data.is_parent,'noofdays':data.noofdays,
      //   'overrideprice':data.overrideprice,'partycode':data.partycode,'pickup_time':data.pickup_time,
      //   'preferredsupplier':data.preferredsupplier,'ratebasis':data.ratebasis,'requestid':data.requestid,
      //   'searchfromdate':data.searchfromdate,'searchtodate':data.searchtodate,'senior':data.senior,
      //   'seniorcostvalue':data.seniorcostvalue,'seniorcplistcode':data.seniorcplistcode,'seniorcprice':data.seniorcprice,
      //   'senioreplistcode':data.senioreplistcode,'seniorprice':data.seniorprice,'seniorsalevalue':data.seniorsalevalue,
      //   'serviceStatus':data.serviceStatus,'service_id':data.service_id,'service_name':data.service_name,
      //   'service_provider_id':data.service_provider_id,'service_ref_id':data.service_ref_id,
      //   'service_status':data.service_status,'service_type':data.service_type,'sm_name':data.sm_name,
      //   'sp_name':data.sp_name,'totalcostvalue':data.totalcostvalue,'totalsalevalue':data.totalsalevalue,
      //   'tourstartingfrom':data.tourstartingfrom,'unitcostvalue':data.unitcostvalue,
      //   'unitcplistcode':data.unitcplistcode,'unitcprice':data.unitcprice,'uniteplistcode':data.uniteplistcode,
      //   'unitprice':data.unitprice,'units':data.units,'unitsalevalue':data.unitsalevalue,'updateduser':data.updateduser,
      //   'updatteddate':data.updatteddate,'vehiclecode':data.vehiclecode,'wladultsalevalue':data.wladultsalevalue,
      //   'wlchildasadultvalue':data.wlchildasadultvalue,'wlchildsalevalue':data.wlchildsalevalue,'wlconvrate':data.wlconvrate,
      //   'wlcurrcode':data.wlcurrcode,'wlmarkupperc':data.wlmarkupperc,'wlseniorsalevalue':data.wlseniorsalevalue,
      //   'wltotalsalevalue':data.wltotalsalevalue,'wlunitsalevalue':data.wlunitsalevalue,'close':'yes'})
      //////console.log(this.excursiondeails.supplierList[this.excursiondeails.supplierList.length-1])

      //////console.log(this.excursiondeails.supplierList)
    }
    else {
      this.toastrService.error('Purchase Invoice is generated so you are not allowed to change cost or supplier', 'Title Error!', { closeButton: true, timeOut: 3000 });
    }
  }
  close_list = []
  is_delte = false
  close_row(data: any, i: any) {
    if (this.excursiondeails.supplierList[i].PI_supplier == "0") { //Condition changed by Ram 18-10-2023
      this.is_delte = true
      this.excursiondeails.totalcostvalue = (+this.excursiondeails.totalcostvalue) - (+this.excursiondeails.supplierList[i].cost[0].costValue)
      this.excursiondeails.supplierList.splice(i, 1)
      //console.log(this.excursiondeails.supplierList)
      this.close_list = this.excursiondeails.supplierList
      //////console.log(i)
      // this.excursiondeails.supplierList[rw].cost[i].noofPaxOrUnit=data.value
      // this.excursiondeails.supplierList[rw].cost[i].costValue=this.excursiondeails.supplierList[rw].cost[i].paxOrUnitRate*data.value
      // this.excursiondeails.supplierList[rw].adults=this.excursiondeails.supplierList[rw].cost[i].filter((r:any)=>r.paxType=='Adult').reduce((sum:any,item:any)=>sum+item.noofPaxOrUnit,0)
      // this.excursiondeails.supplierList[rw].child=this.excursiondeails.supplierList[rw].cost[i].filter((r:any)=>r.paxType=='Child').reduce((sum:any,item:any)=>sum+item.noofPaxOrUnit,0)
      // this.excursiondeails.supplierList[rw].senior=this.excursiondeails.supplierList[rw].cost[i].filter((r:any)=>r.paxType=='senior').reduce((sum:any,item:any)=>sum+item.noofPaxOrUnit,0)
      //   let data_se={"requestid":data['requestid'],"jsonval":this.excursiondeails.supplierList.filter((s:any)=>s.service_ref_id==data.service_ref_id),'elineno':data.elineno,'row_count':1}
      //   this.excursionServiceService.update_multiple_excursion(data_se).subscribe(resp=>{
      //   // let ex_data={'requestid':data['requestid'],'service_ref_id':data['service_ref_id'],'service_type':data['service_type'],'is_multicost':data['is_multicost'],'elineno':data['elineno'],'is_multidate':data['is_multidate'],'servicelist':this.excursiondeails.servicelist}
      //   // // this.excursionServiceService.getexcursion_Details(ex_data).subscribe((res:any)=>{
      //   // //   this.dt.reset()
      //   // //   this.excursiondeails.supplierList=[]
      //   // //   this.excursiondeails.supplierList=res['data'][0].supplierList
      //   // // });
      //   // this.loadexcursiondetails(ex_data)
      //  })
    }
    else {
      this.toastrService.error('Purchase Invoice is generated so you are not allowed to change cost or supplier', 'Title Error!', { closeButton: true, timeOut: 3000 });
    }

  }
  delete_row(delte_data: any, data: any, rowIndex: any) {
    let data_se = { "requestid": this.excursiondeails['requestid'], "jsonval": delte_data.filter((s: any) => s.service_ref_id == data.service_ref_id), 'elineno': this.excursiondeails.elineno, 'row_count': 1 }
    this.excursionServiceService.update_multiple_excursion(data_se).subscribe(resp => {
      this.save_row_data_af_delete(data, rowIndex)
    })
  }
  // onChangeSearch(event:any){

  // }
  getsumguest(ad: any, ch: any, se: any) {
    let va = ad + ch + se
    return va
  }
  cancel() {
    this.loadexcursion_refers(this.excursionForm.value)
  }
  supplierChange(event: any, data: any) {
    //////console.log(event)
    //////console.log(data)
    this.cost_display = true
  }
  save_row_data(data: any, rowIndex: any) {
    if (this.Check_Child_Supplier_New() == true) {
      let tSaleValue: number = 0;
      if(this.appClient == "RoyalPark"){
        tSaleValue = this.excursiondeails.baseCurrtotalsalevalue;
      }
      else{
        tSaleValue = this.excursiondeails.maxtotalsalevalue;
      }
      //if (this.excursiondeails.totalsalevalue >= this.excursiondeails.totalcostvalue) {
      //if (this.excursiondeails.maxtotalsalevalue >= this.excursiondeails.totalcostvalue) {
      if (tSaleValue >= this.excursiondeails.totalcostvalue || data.comp_cust == 1) {
        if (this.is_delte) {
          //console.log('test');
          this.excursionServiceService.setitem(data)
          let adult = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.adults), 0);
          let child = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.child), 0);
          let senior = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.senior), 0);
          //////console.log(adult)
          let unit = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'UNIT');
          if (this.excursiondeails.is_multicost == 0) {
            // if(this.excursiondeails.supplierList.cost.length!=0){
            //   adult=this.excursiondeails.supplierList.cost.filter((s:any)=> s.paxType=='Adult').reduce((sum:any, current:any) => sum + (+current.noofPaxOrUnit), 0);
            // } else{

            // }
            adult = this.excursiondeails.supplierList.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.adults), 0);
            child = this.excursiondeails.supplierList.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.child), 0);
            senior = this.excursiondeails.supplierList.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.senior), 0);
            //////console.log(adult)
            unit = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'UNIT');
          }
          else {
            adult = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.adults), 0);
            child = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.child), 0);
            senior = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.senior), 0);

            unit = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'UNIT');
          }

          if ((this.excursiondeails.adults == adult && this.excursiondeails.child == child && this.excursiondeails.senior == senior) || this.excursiondeails.ratebasis == 'UNIT') {
            this.delete_row(this.excursiondeails.supplierList, data, rowIndex)
          } else {
            this.toastrService.error('Invalid pax count', 'Title Error!', { closeButton: true, timeOut: 3000 });
          }
        } else {
          this.save_row_data_af_delete(data, rowIndex)
        }
      } else {
        this.toastrService.error('cost value higher than sale value', 'Title Error!', { closeButton: true, timeOut: 3000 });
      }
    }
    else {
      this.toastrService.error('Please check child supplier', 'Title Error!', { closeButton: true, timeOut: 3000 });
    }

  }

  groupByExcDate(array: any[], key: string): { [key: string]: any[] } {
    return array.reduce((result, currentValue) => {
      // Get the value for the key by which we're grouping
      const groupKey = currentValue[key];
      
      // If the group doesn't exist yet, create it
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      
      // Add the current value to the group
      result[groupKey].push(currentValue);
      
      // Return the grouped result
      return result;
    }, {});
  }

  save_row_data_af_delete(data: any, rowIndex: any) {
    this.is_delte = false
    console.log('save_row_data_af_delete');
    //console.log(data);
    if (data.PI_supplier == "0") { //Condition changed by Ram 18-10-2023
      let email: any = []
      let email_cd: any = []
      //console.log(this.excursiondeails.supplierList);
      email_cd = this.excursiondeails.supplierList.filter((s: any) => s.notification_li == 'email with comment' && (s.sp_name != '' && s.sp_name != null))
      email = this.excursiondeails.supplierList.filter((s: any) => s.notification_li == 'email' && (s.sp_name != '' && s.sp_name != null))
      if (data.is_multicost == 0) {

        this.excursionServiceService.setitem(this.excursiondeails.supplierList.filter((s: any) => s.notification_li = 'email with comment' && (s.sp_name != '' && s.sp_name != null)))
      } else {
        this.excursionServiceService.setitem([data])
      }

      let adult = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.adults), 0);
      let child = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.child), 0);
      let senior = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.senior), 0);
      //////console.log(adult)
      let unit = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'UNIT');
      console.log('Line no 1964')
      console.log(this.excursiondeails);
      if (this.excursiondeails.is_multicost == 0 && this.excursiondeails.is_multidate == 0 && this.excursiondeails.service_type == 1) { // is_multidate == 0 condition added by Ram 29-05-2024
        // if(this.excursiondeails.supplierList.cost.length!=0){
        //   adult=this.excursiondeails.supplierList.cost.filter((s:any)=> s.paxType=='Adult').reduce((sum:any, current:any) => sum + (+current.noofPaxOrUnit), 0);
        // } else{

        // }
        adult = this.excursiondeails.supplierList.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.adults), 0);
        child = this.excursiondeails.supplierList.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.child), 0);
        senior = this.excursiondeails.supplierList.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.senior), 0);
        //////console.log(adult)
        unit = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'UNIT');
      }
      else if(this.excursiondeails.is_multicost == 0 && this.excursiondeails.is_multidate == 0 && this.excursiondeails.service_type == 3){
        let excdetails:any = this.excursiondeails.supplierList[rowIndex];
        adult = excdetails.adults; //excdetails.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.adults), 0);
        child = excdetails.child; //excdetails.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.child), 0);
        senior = excdetails.senior; //excdetails.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.senior), 0);
        //////console.log(adult)
        unit = excdetails.units; //excdetails.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'UNIT');
      }
      else if(this.excursiondeails.is_multicost == 0 && this.excursiondeails.is_multidate == 1){ // Added by Ram 29-05-2024

        const filteredList = this.excursiondeails.supplierList.filter((s: any) => s.ratebasis != 'UNIT');

        const groupedByDate = this.groupByExcDate(filteredList, 'excdate');
        console.log(groupedByDate);

        const adultSumsByDate = Object.keys(groupedByDate).map(excdate => {
          const group = groupedByDate[excdate];
          const totalAdults = group.reduce((sum: number, current: any) => sum + (+current.adults), 0);
          //const averageAdults = totalAdults / group.length;
          return { excdate, totalAdults };
        });

        const childSumsByDate = Object.keys(groupedByDate).map(excdate => {
          const totalChilds = groupedByDate[excdate].reduce((sum: number, current: any) => sum + (+current.child), 0);
          return { excdate, totalChilds };
        });

        const seniorSumsByDate = Object.keys(groupedByDate).map(excdate => {
          const totalSeniors = groupedByDate[excdate].reduce((sum: number, current: any) => sum + (+current.senior), 0);
          return { excdate, totalSeniors };
        });

        for(var i=0; i < adultSumsByDate.length; i++){
          if(adultSumsByDate[i].totalAdults != this.excursiondeails.adults){
            this.toastrService.error('Invalid pax count', 'Title Error!', { closeButton: true, timeOut: 3000 });
            return;
          }
          else{
            adult = adultSumsByDate[i].totalAdults;
          }
        }

        for(var i=0; i < childSumsByDate.length; i++){
          if(childSumsByDate[i].totalChilds != this.excursiondeails.child){
            this.toastrService.error('Invalid pax count', 'Title Error!', { closeButton: true, timeOut: 3000 });
            return;
          }
          else{
            child = childSumsByDate[i].totalChilds;
          }
        }

        for(var i=0; i < seniorSumsByDate.length; i++){
          if(seniorSumsByDate[i].totalSeniors != this.excursiondeails.senior){
            this.toastrService.error('Invalid pax count', 'Title Error!', { closeButton: true, timeOut: 3000 });
            return;
          }
          else{
            senior = seniorSumsByDate[i].totalSeniors;
          }
        }

        console.log(adultSumsByDate);
        console.log(childSumsByDate);
        console.log(seniorSumsByDate);

        // adult = this.excursiondeails.supplierList.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.adults), 0);
        // child = this.excursiondeails.supplierList.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.child), 0);
        // senior = this.excursiondeails.supplierList.filter((s: any) => s.ratebasis != 'UNIT').reduce((sum: any, current: any) => sum + (+current.senior), 0);
        unit = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'UNIT');
      }
      else {
        adult = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.adults), 0);
        child = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.child), 0);
        senior = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'ACS').reduce((sum: any, current: any) => sum + (+current.senior), 0);

        unit = this.excursiondeails.supplierList.filter((s: any) => s.is_parent == 0 && s.ratebasis == 'UNIT');
      }
      let unitcostvaluelist = this.excursiondeails.supplierList.filter((s: any) => s.unitcostvalue == 0); //Added by Ram 12-06-2023
      //console.log(unitcostvaluelist);
      // if (unitcostvaluelist.length == 0) {
      if ((this.excursiondeails.adults == adult && this.excursiondeails.child == child 
          && this.excursiondeails.senior == senior) || this.excursiondeails.ratebasis == 'UNIT') {

        let datas = this.excursiondeails.supplierList.filter((r: any) => (r.elineno == data.elineno))

        console.log('Line no 2077');
        console.log(datas);

        if(this.appClient == "RoyalPark"){
          if(datas.length > 0){
            for(var i=0; i < datas.length; i++){
              if(datas[i]['totalcostvalue'] == null){
                datas[i]['totalcostvalue'] = datas[i]['units'] * datas[i]['unitcostvalue'];
              }
            }
          }
          console.log(datas);
        }
        
        if (data.is_multicost == 0) {


          let multi_datas = this.excursiondeails.supplierList.filter((r: any) => (r.is_parent != 1))
          let service_date = this.excursiondeails.supplierList.filter((r: any) => (r.service_id == data['service_id']))
          if (multi_datas.length != 0) {

            datas = datas.filter((s: any) => s.child_list = [])
            let data_se = { "requestid": data['requestid'], "jsonval": datas, 'elineno': data.elineno, 'row_count': +(rowIndex) + 1 }
            console.log('Line no 2100');
            console.log(data_se);
            this.excursionServiceService.update_multiple_excursion(data_se).subscribe(m_resp => {
              //////console.log(res)
              // data.cost.push(res.cost[0])


              // this.excursiondeails.totalcostvalue
              // let sup_seco=this.excursiondeails.supplierList.filter((r:any)=>(r.is_parent!=1))
              // datas.filter((s:any)=>s.child_list.filter((r:any)=>(s.cost.push(r.cost[0]))))
              // datas=datas.filter((s:any)=>s.child_list=[])

              let list_data = { 'list_data': datas }
              //console.log(list_data);
              this.excursionServiceService.multi_setsupplier(list_data).subscribe(res => {
                this.excursionServiceService.multi_update_Excursion(list_data).subscribe(resps => {
                  this.excursionServiceService.supplier_remarks_mult(list_data).subscribe(respss => {
                    if (resps['result'] == 1) {

                      this.displayPosition = false
                      if (email.length != 0) {
                        data.agentref = this.excursiondeails.agentref
                        this.sendmail(data)
                      }
                      if (email_cd.length != 0) {
                        // if (this.excursionServiceService.getitem()['list_item'].length!=0){
                        this.displayPosition = false
                        this.router.navigate(['/webqnex/email']);
                        //console.log(this.excursionPageIndex);
                        localStorage.setItem('excursionPageIndex', this.excursionPageIndex.toString());
                        // }
                      }
                      else {
                        this.displayPosition = false
                        this.loadexcursion_refers(this.excursionForm.value)
                        this.toastrService.success('Message Success!', 'Title Success!', { closeButton: true, timeOut: 3000 });
                      }


                    }
                  })
                });
              });
            });

            //////console.log(index)



            // if (email=='email'){
            //   data.agentref=this.excursiondeails.agentref
            //   this.sendmail(data)
            // }
            // else if(email=='email with comment'){
            //   this.displayPosition=false
            //   this.router.navigate(['/webqnex/email']);
            // }
            // else{
            // this.displayPosition=false
            //         this.loadexcursion_refers(this.excursionForm.value)
            //         this.toastrService.success('Message Success!', 'Title Success!',{closeButton:true, timeOut: 3000});}

            // }
            // )
          }
          else {
            let ss = []
            let data_send = Object.assign({}, data)
            if (this.excursiondeails.supplierList[rowIndex].child_list.length != 0) {
              this.excursiondeails.supplierList[rowIndex].child_list.forEach((s_res: any, index: any) => {
                data_send.cost.push(s_res.cost[0])
                if (this.excursiondeails.supplierList[rowIndex].child_list.length - 1 == index) {
                  data_send.child_list = []
                  this.excursionServiceService.setsupplier(data_send).subscribe(res => {
                    this.excursionServiceService.update_Excursion(data_send).subscribe(resp => {
                      this.excursionServiceService.update_supplier_remarks(data_send).subscribe(respss => {
                        if (resp['result'] == 1) {
                          this.displayPosition = false
                          if (email.length != 0) {
                            data.agentref = this.excursiondeails.agentref
                            this.sendmail(data)
                          }
                          if (email_cd.length != 0) {
                            // if (this.excursionServiceService.getitem()['list_item'].length!=0){
                            this.displayPosition = false
                            this.router.navigate(['/webqnex/email']);
                            //console.log(this.excursionPageIndex);
                            localStorage.setItem('excursionPageIndex', this.excursionPageIndex.toString());
                            // }
                          }
                          else {
                            this.displayPosition = false
                            this.loadexcursion_refers(this.excursionForm.value)
                            this.toastrService.success('Message Success!', 'Title Success!', { closeButton: true, timeOut: 3000 });
                          }
                        }
                      })
                    });
                  })
                }

              })
            }
            else {
              //console.log(data_send);
              this.excursionServiceService.setsupplier(data_send).subscribe(res => {
                this.excursionServiceService.update_Excursion(data_send).subscribe(resp => {
                  this.excursionServiceService.update_supplier_remarks(data_send).subscribe(respss => {
                    if (resp['result'] == 1) {
                      this.displayPosition = false
                      if (email.length != 0) {
                        data.agentref = this.excursiondeails.agentref
                        this.sendmail(data)
                      }
                      if (email_cd.length != 0) {
                        // if (this.excursionServiceService.getitem()['list_item'].length!=0){
                        this.displayPosition = false
                        this.router.navigate(['/webqnex/email']);
                        //console.log(this.excursionPageIndex);
                        localStorage.setItem('excursionPageIndex', this.excursionPageIndex.toString());
                        // }
                      }
                      else {
                        this.displayPosition = false
                        this.loadexcursion_refers(this.excursionForm.value)
                        this.toastrService.success('Message Success!', 'Title Success!', { closeButton: true, timeOut: 3000 });
                      }
                    }
                  })
                });
              })
            }
            // this.excursiondeails.supplierList[rowIndex].child_list.filter((r:any)=>data.cost.push(r.cost[0]))
            // console.log(data)

          }
        }

        else if (datas.length > 0 && data.is_multicost == 1) {
          datas.forEach((res: any, index: any) => {
            //////console.log(res)
            // data.cost.push(res.cost[0])
            if (datas.length - 1 == index) {
              data['rate_type'] = this.excursiondeails.ratebasis
              data['totalcostvalue'] = this.excursiondeails.totalcostvalue
              // this.excursiondeails.totalcostvalue
              //console.log(data);
              this.excursionServiceService.setsupplier(data).subscribe(res => {
                this.excursionServiceService.update_Excursion(data).subscribe(resp => {
                  if (resp['result'] == 1) {
                    this.excursionServiceService.update_supplier_remarks(data).subscribe(respss => {
                      //console.log(respss)
                    })
                    this.displayPosition = false
                    if (email.length != 0) {
                      data.agentref = this.excursiondeails.agentref
                      this.sendmail(data)
                    }
                    if (email_cd.length != 0) {
                      // if (this.excursionServiceService.getitem()['list_item'].length!=0){
                      this.displayPosition = false
                      this.router.navigate(['/webqnex/email']);
                      //console.log(this.excursionPageIndex);
                      localStorage.setItem('excursionPageIndex', this.excursionPageIndex.toString());
                      // }
                    }
                    else {
                      this.displayPosition = false
                      this.loadexcursion_refers(this.excursionForm.value)
                      this.toastrService.success('Message Success!', 'Title Success!', { closeButton: true, timeOut: 3000 });
                    }
                  }

                });
              });
            }
            //////console.log(index)

          });

        }
        else {
          data['rate_type'] = this.excursiondeails.ratebasis
          //console.log(data);
          this.excursionServiceService.setsupplier(data).subscribe(res => {


            this.excursionServiceService.update_Excursion(data).subscribe(resp => {
              if (resp['result'] == 1) {
                this.displayPosition = false
                if (email.length != 0) {
                  data.agentref = this.excursiondeails.agentref
                  this.sendmail(data)
                }
                if (email_cd.length != 0) {
                  // if (this.excursionServiceService.getitem()['list_item'].length!=0){
                  this.displayPosition = false
                  this.router.navigate(['/webqnex/email']);
                  //console.log(this.excursionPageIndex);
                  localStorage.setItem('excursionPageIndex', this.excursionPageIndex.toString());
                  // }
                }
                else {
                  this.loadexcursion_refers(this.excursionForm.value)
                  this.toastrService.success('Message Success!', 'Title Success!', { closeButton: true, timeOut: 3000 });
                }
              }

            });
          });
        }
        // });
      }
      else {
        this.toastrService.error('Invalid pax count', 'Title Error!', { closeButton: true, timeOut: 3000 });

      }
      // }
      // else {
      //   this.toastrService.error('Please fill cost/price price', 'Title Error!', { closeButton: true, timeOut: 3000 });
      // }
    }
    else {
      this.toastrService.error('Purchase Invoice is generated so you are not allowed to change cost or supplier', 'Title Error!', { closeButton: true, timeOut: 3000 });
    }

  }
  sendmail(data: any) {
    this.excursionServiceService.smtp_mail_send(data).subscribe(res => {
      //////console.log(res)
    })
  }
  //   onReject() {
  //     this.messageService.clear('c');
  // }

  loadexcursiontype() {
    this.excursionServiceService.excursionTypeslist().subscribe(res => {
      if (res['result'] == 1) {
        this.excursion_typeslist = res['data'];
        this.excursionServiceService.prioritylist().subscribe((res: { [x: string]: any; }) => {
          if (res['result'] == 1) {
            this.prioritylist = res['data'];
            this.prioritylist.unshift({ "priority_id": 0, "priority_name": 'Show All' })
            this.loadsupplierdetails({})
          }
        });
      }

    });

  }

  //remark Save
  saveremarks(data: any) {
    //////console.log(data)
    this.excursionServiceService.update_service_remarks(data).subscribe(res => {
      if (res['result'] == 1) {
        this.toastrService.success('Message Success!', 'Title Success!', { closeButton: true, timeOut: 3000 });

      }

    });

  }

  savelocation(data: any = {}) {
    let va = Object.assign({}, data);
    // va.location=data.location['partyname']
    this.excursionServiceService.update_service_location(va).subscribe(res => {
      if (res['result'] == 1) {
        this.toastrService.success('Message Success!', 'Title Success!', { closeButton: true, timeOut: 3000 });

      }

    });

  }


  supplier_list: any = []
  supplier_list_copy: any = []
  loadsupplierdetails(data: {}) {
    this.excursionServiceService.getsupplier_list(data).subscribe((res: { [x: string]: any; }) => {
      if (res['result'] == 1) {
        this.supplier_list = res['data'];
        this.supplier_list_copy = res['data'];
        this.loadbusinessunit()
        //////console.log(this.supplier_list)
        // this.loadexcursion(this.excursionForm.value)


      }

    }

    );
  }
  bussiness_list: any = []
  loadbusinessunit() {
    this.excursionServiceService.businessunitlist().subscribe((res: { [x: string]: any; }) => {
      if (res['result'] == 1) {
        this.bussiness_list = res['data']
        //////console.log(this.supplier_list)
        // this.loadexcursion(this.excursionForm.value)


      }

    }

    );
  }
  filechage = 'Test'
  referesh_btn = false

  refresh() {
    this.referesh_btn = true
    this.loadexcursion_refers(this.excursionForm.value)
    setTimeout(
      () => {
        this.referesh_btn = false;
        //console.log(new Date())
      }, 30000
    );

  }
  filechange(event: any, product: any) {
    //////console.log(event)
    //////console.log(product)

    console.log(event.target.files.size)
    let val = (event.target.files[0].size / (1024 * 1024));
    if (val > 5) {
      this.toastrService.error('Invalid File', 'Title Error!', { closeButton: true, timeOut: 3000 });
      event.target.value = '';
      return false
    } else {
      this.confirmation_list[product]['file'] = event.target.files
      let formData = new FormData();
      // this.selectedFiles = event.target.files;
      // this.currentFileUpload = event.target.files.item(0);
      //////console.log(event.target.files.item(0))
      formData.append('file', event.target.files.item(0));
      formData.append('name', 'test');
      //////console.log(JSON.stringify(formData))
      formData.forEach((value, key) => {
        //////console.log(key+" "+value)
      });
      return
    }
    // formData.append('name', fileName);
    // formData.append('file', fileContent);
  }
  savefile_confirmation(data: any) {
    //////console.log(data)
    let formData = new FormData();
    // formData.append('file', data.item(0));
    // formData.append('name', 'test');

    // form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
    if(data['file'] != ""){
      formData.append('file', data['file'].item(0));
    }

    // let formData: FormData = new FormData();
    // formData.append('data',JSON.stringify(data) );
    formData.append('requestid', data['requestid']);
    formData.append('service_id', data['service_id']);
    formData.append('excdate', data['excdate']);
    formData.append('service_name', data['service_name']);
    formData.append('service_provider_id', data['service_provider_id']);
    //formData.append('confirmid', data['confirmid']);
    formData.append('confirmid',data['confirmation_id']);
    formData.append('eline', data['eline']);
    //////console.log(JSON.stringify(formData))
    formData.forEach((value, key) => {
      //////console.log(key+" "+value)
    });
    //   for (var key in formdata) {
    //     //////console.log(key, formdata[key]);

    // }
    this.excursionServiceService.updatefile_confirmation(formData).subscribe(r => {
      //////console.log(r)
      this.toastrService.success('Message Success!', 'Title Success!', { closeButton: true, timeOut: 3000 });
    });
  }
  reset() {
    this.excursionForm.reset()
    this.excursionForm.patchValue({
      excursion_from_date: new Date(),
      excursion_to_date: new Date(),
      request_from_date: '',
      request_to_date: '',
      priority: '',
      bussinessunit: '',
      status: '',
      searchkeyword: '',
      sel_search_type: 0,
      order_by: '',
      excursion_types: '',
      excursion_classification: '',
      excursion_pickuplocation: '',
      amendment: '',
      offset: '0',
      per_page: '100'
    })

    this.excursionForm.patchValue({
      offset: '0',
      per_page: '100'
    })

    if(this.appClient == "RoyalPark"){
      this.excursionForm.patchValue({
        order_by: 5,
      })
    }

  }
  numbersOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  numbersWithDecimalOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    var number = event.target.value.split('.');
    //console.log(charCode + ' CharCode');
    if (number.length == 2 && charCode == 46) {
      return false
    }
    if (number[number.length - 1].length > 1 && number.length == 2) {
      return false
    }
    else if (charCode == 46) {
      return true;
    }


    else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  onExcursionPageChange(event: any) {
    this.excursionPageIndex = ((event.first / event.rows) + 1);
    //console.log('Page Index '+ this.excursionPageIndex);
    //console.log(event);
    this.excursionPageIndex = (this.excursionPageIndex * event.rows) - 10;
    //console.log(this.excursionPageIndex);
    //localStorage.setItem('excursionPageIndex',this.excursionPageIndex.toString());
  }

  selectAllForDropdownItems(items: any[]) {
    let allSelect = (items: any[]) => {
      items.forEach(element => {
        element['selectedAllGroup'] = 'selectedAllGroup';
      });
    };

    allSelect(items);
  }

  getExcursionRowClass(item: any) : string{
    let className = "";
    if(this.appClient == "RoyalPark"){
      if(item.service_status == 1){ // Pending
        className = "pending_row";
      }
      else if(item.service_status == 2){ // Assigned
        className = "assigned_row";
      }
      else if(item.service_status == 3){ // Confirmed
        className = "confirmed_row";
      }
      else if(item.service_status == 5){ // Rejected
        className = "rejected_row";
      }
    }
    else if(this.appClient != "RoyalPark"){
      if( item.service_status == 1){
        className = "pink_row";
      }
    }

    return className;
  }

  getServiceStatus(status: number): string{
    let strstatus: string = "";
    if(status == 1){
      strstatus = "Pending";
    }
    else if(status == 2){
      strstatus = "Assigned";
    }
    else if(status == 3){
      strstatus = "Confirmed";
    }
    else if(status == 4){
      strstatus = "Cancelled";
    }
    else if(status == 5){
      strstatus = "Rejected";
    }
    else{
      strstatus = "Pending";
    }
    return strstatus;
  }

  getExcursiondataForExport(data: any){
    this.totalAdults = 0;
    this.totalChilds = 0;
    for (let i = 0; i < data.length; i++) {
      const item = data[i];

      this.totalAdults += item.adults;
      this.totalChilds += item.child;

      let child:string = "";
      if(item.childages != ""){
        child = item.child + " (" + item.childages + ")";
      }
      else{
        child = item.child;
      }

      // Transforming data structure
      const transformedItem = {
        "SERVICEDATE": item.ServiceDate,
        "AGENCYNAME": item.agentname,
        "REQUESTID": item.requestid,
        "VOUCHERNO": item.voucherno,
        "ADULT" : item.adults,
        "CHILD": child,
        //"CHILDAGE": item.childages,
        "TOTALPAX": parseInt(item.adults) + parseInt(item.child),
        "GUESTNAME": item.guestname,
        "PICKUPLOCATION": item.Location,
        "PICKUPTIME": item.PickupTime,
        "SERVICENAME": item.servicelist,
        "MAINSUBSERVICE": (item.is_parent == 1) ? "MAIN" : "SUB",
        "SUPPLIER": (item.supplier == undefined || item.supplier == null) ? "": item.supplier,
        "CATEGORYSICPVT": item.SICPrivate,
        "SERVICESTATUS": this.getServiceStatus(item.service_status),
        "REMARKS": item.Partyremarks
      };

      // Pushing transformed item to target data
      this.excursionlist_export.push(transformedItem);
    }
  }

  excursionExcelExport(){
    const currentDate = new Date();
    const formattedDate = this.datePipe.transform(currentDate, 'ddMMyyyyHHmmss');
    let fileName = "";
    fileName = "Excursion_" + formattedDate + ".xlsx";

    let excfromdate;
    let exctodate;
    if(this.excursionForm.value['excursion_from_date'] != '' && this.excursionForm.value['excursion_from_date'] != null){
      this.excursionForm.value['excursion_from_date'] = new Date(this.excursionForm.value['excursion_from_date'])
      this.excursionForm.value['excursion_from_date'] = new Date(this.excursionForm.value['excursion_from_date'].getTime() - this.excursionForm.value['excursion_from_date'].getTimezoneOffset()*60000).toISOString();
      excfromdate = this.datePipe.transform(this.excursionForm.value.excursion_from_date, 'dd-MM-yyyy');
    }

    if(this.excursionForm.value['excursion_to_date'] != '' && this.excursionForm.value['excursion_to_date'] != null){
      this.excursionForm.value['excursion_to_date'] = new Date(this.excursionForm.value['excursion_to_date'])
      this.excursionForm.value['excursion_to_date'] = new Date(this.excursionForm.value['excursion_to_date'].getTime() - this.excursionForm.value['excursion_to_date'].getTimezoneOffset()*60000).toISOString();
      exctodate = this.datePipe.transform(this.excursionForm.value.excursion_to_date, 'dd-MM-yyyy');
    }

    let va ={
      "data": this.excursionlist_export,
      "totalAdults": this.totalAdults,
      "totalChilds": this.totalChilds,
      "fromdate": excfromdate,
      "todate": exctodate
    }

    this.excursionServiceService.export_ExcursionReport(va).subscribe((blob: Blob) => {
      // Create a blob URL for the Blob object
      const url = window.URL.createObjectURL(blob);

      // Create a link element and set its attributes
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      // Trigger the download by simulating a click on the link
      link.click();

      // Clean up by revoking the blob URL
      window.URL.revokeObjectURL(url);
    },
    error => {
      // Handle error
      console.error('Error downloading file:', error);
    });
  }

  redirect_email(data: any, rowIndex: any){
    let rowData = this.excursiondeails.supplierList[rowIndex];
    rowData['notification_li'] = "email with comment";
    if (data.is_multicost == 0) {
      this.excursionServiceService.setitem(this.excursiondeails.supplierList.filter((s: any) => s.notification_li = 'email with comment' && (s.sp_name != '' && s.sp_name != null)))
    } else {
      this.excursionServiceService.setitem([data])
    }

    this.router.navigate(['/webqnex/email']);
  }
}
